<template>
    <!-- copy from here -->

    <div class="wage-setting" data-testid="wage-setting-root">
        <div class="container-fluid p-0">
            <div class="row justify-content-center d-none d-md-block">

                <table style="width:100%" class="main-nav-table">
                    <tr>
                        <td v-if="hideoverview == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-1" v-bind:class="{'selected':step == 1}" @click="step = 1">
                                Översikt
                            </div>
                        </td>
                        <td v-if="hidesalarysteps == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidesalarysteps == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-2" v-bind:class="{'selected':step == 2}" @click="step = 2">
                                Lönestapel
                            </div>
                        </td>
                        <td v-if="hideevaluatebasework == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideevaluatebasework == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-3" v-bind:class="{'selected':step == 3}" @click="step = 3">
                                Värdera<br />grundarbetet
                            </div>
                        </td>
                        <td v-if="hideevaluatedevelopmentblocks == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideevaluatedevelopmentblocks == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-4" v-bind:class="{'selected':step == 4}" @click="step = 4">
                                Värdera<br />utvecklings-<br />block
                            </div>
                        </td>
                        <td v-if="hideindividualaddons == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideindividualaddons == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-5" v-bind:class="{'selected':step == 5}" @click="step = 5">
                                Individuella<br />tillägg
                            </div>
                        </td>
                        <td v-if="hidedynamic == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidedynamic == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-6" v-bind:class="{'selected':step == 6}" @click="step = 6">
                                Rörlig<br />lönedel
                            </div>
                        </td>
                        <td v-if="hideindividuals == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideindividuals == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-7" v-bind:class="{'selected':step == 7}" @click="step = 7">
                                Inplacering<br />av individer
                            </div>
                        </td>
                        <td v-if="hidemoney == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidemoney == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-8" v-bind:class="{'selected':step == 8}" @click="step = 8">
                                Pengar<br />i systemet
                            </div>
                        </td>
                        <td v-if="hideresult == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideresult == false" class="large-button-container">
                            <div class="p-1 large-button rounded purple" data-testid="wage-setting-step-9" v-bind:class="{'selected':step == 9}" @click="step = 9">
                                Resultatet
                            </div>
                        </td>
                    </tr>
                </table>

            </div>
            <div class="row justify-content-center mt-3">
                <div v-if="hideoverview == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 1}" @click="step = 1">
                        <span v-html="'Översikt'"></span>
                    </div>
                </div>
                <div v-if="step == 1" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step1-lonesystem-vad-ar-det"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,concepts,lonesystem">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Lönesystem - vad är det?
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded" data-manual-info-body>
                                    <div class="pt-2 pb-4 col-md-7">
                                        Det är viktigt att känna till skillnaden mellan ett framförhandlat lönesystem och ett system som endast syftar till att fördela pengarna vid lönerevisioner.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel eager class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Lönesystem
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Ett lönesystem är en lokal överenskommelse om vilka lönedelar lönesystemet består av, hur de konstrueras, värdet samt regler för bland annat inplacering i systemet, uppflyttningar etc.
                                                        </p>
                                                        <p>
                                                            När en anställd utvecklas i sitt arbete, utvecklas även lönen enligt de regler som fastställts. Alla som utför samma arbete får samma lön. Finns det individuella lönedelar i lönesystemet får alla som uppfyller kriterierna samma tillägg.
                                                        </p>
                                                        <p>
                                                            Vid löneförhandlingar enligt riksavtalet höjs värdet på de lönedelar som ingår i lönesystemet. Det innebär att värdet av potten finns kvar i lönesystemet även om enskilda personer lämnar företaget.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel eager class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Fördelningssystem
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Ett lönesystem skiljer sig från ett ”fördelningssystem”. Fördelningssystemet bestämmer endast hur den lokala potten ska fördelas på företaget. Vid fördelningen får varje anställd en individuell lön, efter hur han/hon har utvecklats under året.
                                                        </p>
                                                        <p>
                                                            I ett fördelningssystem ligger inte värdet av tidigare löneförhandlingar enligt riksavtalet kvar i systemet. Om en nyanställd inte hamnar rätt lönemässigt är det risk för att en stor del av potten går till att justera felaktiga löneskillnader mellan nyanställda och tidigare anställda i stället för att höja det allmänna löneläget.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step1-styrkan-med-lonesystem"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,overview,lonesystem">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Styrkan med lönesystem
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        Det finns många fördelar med ett lönesystem, förutsatt att det är väl genomtänkt. Det kräver en del arbete, men det är ett arbete som betalar sig.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Lönesättning lika för alla
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Lönesättningen blir lika för alla, utifrån ett fastställt regelverk och tydliga och väldefinierade lönefaktorer. Det blir därmed mindre godtycke i lönesättningen.
                                                        </p>
                                                        <p>
                                                            Lönesystem minskar risken för osakliga löneskillnader mellan män och kvinnor. Lönesystem är också ett sätt att säkra att arbetskamrater med ursprung i andra länder får den lön de ska ha för det arbete de utför.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Accepterade löneskillnader
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Ett genomarbetat lönesystem som diskuterats brett skapar en acceptans för de löneskillnader som finns på företaget. Alla förstår varför den egna lönen ligger där den ligger och varför arbetskamraten har en annan lön. Alla vet också hur de ska agera för att höja sin lön. Det minskar risken för konflikter på arbetsplatsen.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Ökad delaktighet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Ett lönesystem som är genomarbetat och som har diskuterats brett på arbetsplatsen innan det sjösätts uppfattas som mer rättvist.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Stödjer utvecklingen i arbetet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Lönesystem ska byggas upp så att de ger möjlighet till utveckling inom ramen för befattningen. Det gör det tydligt för alla vad de kan göra för att höja sin kompetens och ta på sig mer kvalificerade arbetsuppgifter.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Mer pengar i lönekuvertet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Den som ökat sin kompetens och tar på sig mer kvalificerade arbetsuppgifter, ska också få påslag på lönen. Det ger mer pengar i lönekuvertet.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Visa vilken kompetens som finns
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Kompetensläget på företaget synliggörs genom att lönesystemet definierar vilka arbetsuppgifter det finns på företaget och vilken kompetens de kräver. Lönesystemet visar därmed snabbt vilka som kan och gör vad. Det är ett stöd i arbetet med att utveckla de anställdas kompetens och stärker därmed företagets konkurrensförmåga.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Värdet ligger kvar
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Vid lönerevision höjs värdet på de lönedelar som ingår i lönesystemet. Det innebär att värdet av potten finns kvar i lönesystemet även om enskilda personer lämnar företaget. Nyanställda får del av tidigare potter genom att värdet på de olika lönedelarna höjts.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Ökar företagets lönsamhet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Ett bra lönesystem stimulerar de anställda till att utvecklas i befattningen. De blir mer motiverade och engagerade i arbetet. Det bidrar till att företagets lönsamhet förbättras.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step1-vad-ar-rattvis-lon"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,overview,rattvis-lon">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Vad är rättvis lön?
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        En första fråga man kan ställa sig är om det finns någon ”absolut rättvisa”. Kanske handlar det snarare om att vi ska sträva efter löneskillnader på företaget som är sakliga och accepterade – och som därmed i alla fall upplevs som rättvisa.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Olika principer för rättvisa
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Att frågan om rättvisa inte är enkel framgår inte minst av nedanstående lista på möjliga rättviseprinciper:
                                                        </p>
                                                        <p>
                                                        </p><table>
                                                            <tbody>
                                                                <tr>
                                                                    <th scope="row" align="left" style="width: 150px">Arbetets krav</th>
                                                                    <td>
                                                                        Den som har ett arbete som ställer högre krav ska ha högre lön än den med ett enklare arbete.
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row" align="left" style="width: 150px">Meriter</th>
                                                                    <td>
                                                                        Den med exempelvis mer yrkeserfarenhet, utbildning eller anställningstid ska ha högre lön.
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row" align="left" style="width: 150px">Produktivitet</th>
                                                                    <td>
                                                                        Den som får mer gjort än andra ska ha högre lön.
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row" align="left" style="width: 150px">Beteende</th>
                                                                    <td>
                                                                        Den som utför sitt arbete på ett bättre sätt ska ha högre lön.
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row" align="left" style="width: 150px">Marknad</th>
                                                                    <td>
                                                                        Den som är mer efterfrågad på arbetsmarknaden ska ha högre lön.
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th scope="row" align="left" style="width: 150px">Likabehandling</th>
                                                                    <td>
                                                                        Alla ska ha samma lön eftersom alla bidrar och gör så gott de kan.
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Vad påverkar upplevelsen av rättvisa?
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            En förutsättning för att ett system för lönesättning ska upplevas som rättvist är att medlemmarna är delaktiga i arbetet med att utforma systemet.
                                                        </p>
                                                        <p>
                                                            Delaktigheten har betydelse också utifrån andra aspekter.
                                                        </p>
                                                        <p>
                                                            Genom att medlemmarnas kunskap om företaget och kraven i arbetet tas tillvara ökar möjligheterna att skapa ett riktigt bra system för lönesättningen. Delaktigheten gör därtill att alla förstår systemet bättre, vilket säkrar att det tillämpas på rätt sätt.
                                                        </p>
                                                        <p>
                                                            Detta är av största vikt också för arbetsgivaren. Om lönesättningen inte upplevs som rättvis inverkar det negativt såväl på motivation och samarbete, som på effektivitet och produktivitet.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Arbetet med att ta fram systemet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Det är inte bara i resonemanget om rättvisa som medlemmarna ska vara delaktiga,
                                                            utan också i arbetet med att skapa själva systemet för hur lönen ska sättas på
                                                            företaget. Här är några exempel på frågor som måste diskuteras inför detta arbete.
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                Hur ska ett lönesystem utformas så att det bidrar till utveckling i arbetet?<br>
                                                                Vilken utveckling vill vi ha? Hur borde arbetsorganisationen se ut?
                                                            </li>
                                                            <li>Vad ska löneskillnaderna grundas på?</li>
                                                            <li>Ska det vara samma grundlön för alla befattningar eller olika?</li>
                                                            <li>Hur ska kopplingen mellan utveckling i arbete och utveckling i lön se ut?</li>
                                                            <li>Ska det finnas ett tak för möjligheten till utveckling i lön?</li>
                                                        </ul>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Några enkla tumregler
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Det finns några enkla tumregler att hålla sig till för att lönesättningen ska bli accepterad på arbetsplatsen.
                                                        </p>
                                                        <p>
                                                        </p><ul>
                                                            <li>De anställda ska vara delaktiga i arbetet med att utveckla lönesystemet.</li>
                                                            <li>Lönefaktorerna ska vara tydliga, meningsfulla och möjliga att nå.</li>
                                                            <li>De ska tillämpas konsekvent, oavsett situation eller person. Såväl fack som företag ska vara lojala mot lönesystemet och följa uppsatta kriterier och regler.</li>
                                                            <li>Lönerna ska vara öppna så att alla kan jämföra den egna lönen med andras.</li>
                                                            <li>
                                                                Bedömningar och beslut ska bygga på korrekt information, med möjlighet till
                                                                rättelse om något ändå blir fel.
                                                            </li>
                                                            <li>
                                                                Lönesättningen ska baseras på grundläggande etiska normer<br>
                                                                (exempelvis att alla ska behandlas likvärdigt).
                                                            </li>
                                                        </ul>
                                                        <p></p>
                                                        <p>
                                                            Sammanfattningsvis: Alla ska veta på vilka grunder lönen har satts och vad som krävs för att få en höjd lön.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step1-prova-varderingarna"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,overview,varderingar,jamstalldhet">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Pröva värderingarna i grunden
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            För en så rättvis lönesättning som möjligt krävs att vi vet vilka arbetsuppgifter varje anställd har och att vi värderar dem på ett enhetligt och konsekvent sätt.
                                        </p>
                                        <p>
                                            Värderingen ska bygga på en samsyn om vilka rättviseprinciper som lönesättningen ska utgå från och hur de ska omsättas i lönefaktorer. Värderingen ska också bygga på en systematisk beskrivning av de arbetsuppgifter som ingår i befattningen.
                                        </p>
                                        <p>
                                            Det kan låta enkelt, men det kräver en hel del arbete. Det handlar om att lägga en stabil bas för lönesättningen på företaget. Den svåraste delen i detta arbete är dock att i grunden pröva sina värderingar, värderingar som vi ofta vuxit upp med.
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Jämställda löner
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Prövningen av våra värderingar är en viktig del i arbetet för att skapa jämställda löner. Det handlar om att diskutera sig fram till så könsneutrala värderingar som möjligt.
                                                        </p>
                                                        <p>
                                                            Här kan nedanstående exempel vara till hjälp.
                                                        </p>
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Exempel 1
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        På en fråga till LO-medlemmar om vad som ska påverka lönen, är det fler som
                                                                        anger <i>fysiskt slitsamt arbete än enformigt arbete.</i> Samtidigt vet vi att enformigt
                                                                        arbete sliter väl så hårt på kroppen som det fysiskt slitsamma arbetet – kanske mer.
                                                                    </p>
                                                                    <p>
                                                                        Är det här en värdering som vi vill ta med oss i vårt fortsatta lönearbete? Vad beror
                                                                        den på? Hur påverkar den lönesättningen på företaget?
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Exempel 2
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Det finns studier som visar att den relativa lönenivån för olika yrken tenderar att sjunka när andelen kvinnor i respektive yrke ökar. Medan den i stället stiger när andelen män ökar.
                                                                    </p>
                                                                    <p>
                                                                        Påverkar de här mekanismerna också lönesättningen på det egna företaget? Kan det vara så att när vissa arbetsuppgifter huvudsakligen utförs av kvinnor blir löneläget automatiskt något lägre? Gör vi omedvetet bedömningen att eftersom det är många kvinnor som jobbar med det här så kan det inte vara så svårt (för det är ju på enklare jobben kvinnorna oftast finns). Bedömer vi de arbetsuppgifter som utförs av män som lite svårare? Eftersom det är mest män som jobbar med dem?
                                                                    </p>
                                                                    <p>
                                                                        Hur påverkar i så fall detta lönerna för de kvinnodominerade respektive mansdominerade jobben på företaget?
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Exempel 3
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Det finns ibland tendenser till att ”tekniska” arbetsuppgifter värderas högt, jämfört med andra arbetsuppgifter. När den nya tekniken kom och ännu inte var så användarvänlig, var det kanske motiverat – men är det
                                                                        i dag självklart att det är svårare att sköta maskinutrustningen på ett tvätteri än att exempelvis sortera, hänga och packa tvätten?
                                                                    </p>
                                                                    <p>
                                                                        Kan det här synsättet påverka lönesättningen på företaget?
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Vad som ska påverka lönen
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            En del i arbetet med att komma fram till vad som ska påverka lönen är att gå igenom de riktlinjer för lönesättningen som finns i det egna riksavtalet.
                                                        </p>
                                                        <p style="padding-left: 10px">
                                                            <strong>Fakta</strong><br>
                                                            Avtalen finns på medlemsportalen <a href="http://www.ifmetall.se/portal" target="_blank">www.ifmetall.se/portal</a>. De finns också att beställa från förbundsavdelningen.
                                                        </p>
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Allokemisk industri
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>Riktlinjerna för lönesättningen varierar mellan avtalen. I avtalet Allokemisk industri lyfts följande faktorer fram:</p>
                                                                    <p>
                                                                    </p><ul style="list-style-image:url('../gfx/dash.png');">
                                                                        <li>arbetsuppgifternas art och innehåll</li>
                                                                        <li>hur de utförs</li>
                                                                        <li>de kompetenskrav som ställs</li>
                                                                        <li>uppnådda resultat.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Teknikavtalet IF Metall
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Löneprinciperna i Teknikavtalet IF Metall ger fler exempel på möjliga faktorer som lönen kan grundas på. Vissa rör krav i arbetet och andra sättet att utföra arbetet på:
                                                                    </p>
                                                                    <p>
                                                                    </p><ul style="list-style-image:url('../gfx/dash.png');">
                                                                        <li>arbetsuppgifternas svårighetsgrad</li>
                                                                        <li>krav på skicklighet och kompetens</li>
                                                                        <li>ansvar och ökade befogenheter</li>
                                                                        <li>teoretiska/praktiska kunskaper samt ökad erfarenhet</li>
                                                                        <li>den anställdes sätt att uppfylla kraven i arbetet och uppnådda resultat</li>
                                                                        <li>ansträngning och arbetsmiljö</li>
                                                                        <li>omdöme och initiativ, liksom samarbets- och ledningsförmåga</li>
                                                                        <li>förutsättningarna för hur arbetet kan utföras</li>
                                                                        <li>marknadskrafter.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Vad innebär det för oss?
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        När de lokala parterna går igenom riksavtalets skrivningar om vad som ska påverka lönen måste de också ta ställning till om alla de faktorer som nämns i riksavtalet är tillämpliga på företaget, liksom om någon/några lönefaktorer bör föras till.
                                                                    </p>
                                                                    <p>
                                                                        En viktig del i arbetet är också att tydliggöra vad lönefaktorerna ska innebära i praktiken på företaget.
                                                                    </p>
                                                                    <p>
                                                                    </p><ul>
                                                                        <li>Hur ska <i>ansvar i arbetet</i> definieras? Är det hur självständigt den anställda arbetar? Handlar det om konsekvenserna om någon gör fel i arbetet? Annat?</li>
                                                                        <li>Hur ska <i>arbetets svårighetsgrader</i> definieras? Vad är svårt och vad är lätt? Hur graderar man svårigheten? Här är det viktigt att ta med sig diskussionen om de grundläggande värderingarna utifrån ett jämställdhetsperspektiv.</li>
                                                                        <li>Vad ska <i>krav på kompetens</i> innebära? Att utbildning och yrkeserfarenhet ska ge högre lön eller att lönen höjs när man klarar de arbetsuppgifter som kompetensen behövs för?</li>
                                                                        <li>Hur beskrivs den anställdas <i>sätt att uppfylla kraven i arbetet</i>? Är det att prestera mycket eller är det kvaliteten i arbetet som avgör? Är det att behärska många olika arbetsuppgifter eller är det att vara specialiserad? Är det att kunna samarbeta? Är det att bemöta kunder på ett bra sätt?</li>
                                                                        <li>Vilka typer av belastning i <i>arbetsmiljön</i> ska påverka lönen? Vilken inverkan ska dessa ha på lönen? Ska varje arbetsmiljöbelastning ha samma inverkan? Vad händer med lönen när arbetsmiljön förbättrats?</li>
                                                                        <li>När ska <i>marknadskrafterna</i> få påverka lönen? Kan man formulera riktlinjer för detta på företaget?</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        Först när detta är gjort blir lönefaktorerna begripliga. Först då kan de stimulera de anställda till att arbeta på det sätt som bedöms som viktigt både för deras och företagets utveckling.
                                                                    </p>
                                                                    <p>
                                                                        Därtill måste det finnas ett långsiktigt perspektiv i valet av lönefaktorer. De ska ge utveckling i arbetet och därmed i lön, inte bara i nuet utan också framöver.
                                                                    </p>
                                                                    <p>
                                                                        Vart tredje år ska alla företag göra en lönekartläggning, utifrån diskrimineringslagens krav.
                                                                    </p>
                                                                    <p>
                                                                        De avgörande skillnaderna mellan en <i>löneanalys</i> enligt kollektivavtalet och <i>lönekartläggning</i> enligt diskrimineringslagen är:
                                                                    </p>
                                                                    <p>
                                                                    </p><ul style="list-style-image:url('../gfx/dash.png');">
                                                                        <li>att löneanalys endast omfattar befattningar inom det egna kollektivavtalsområdet, medan lönekartläggningen jämför lönerelationerna över avtalsgränserna</li>
                                                                        <li>att löneanalysen fokuserar på alla slags osakliga löneskillnader, inte bara osakliga löneskillnader relaterat till kön.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        Både för Teknikavtalet IF Metall och för avtalen inom Industri- och Kemigruppens område har partsgemensamt material tagits fram som stöd i lönekartläggningen.
                                                                    </p>
                                                                    <p>
                                                                        IF Metall har dessutom tagit fram ett handledningsmaterial för både jämställdhetsplan och handlingsplan för jämställda löner.
                                                                    </p>
                                                                    <p>
                                                                        Materialen finns på medlemsportalen, som nås via <a href="www.ifmetall.se&quot;">www.ifmetall.se</a>.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step1-utveckla-foretag-och-anstallda"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,overview,utveckling">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Lönesystem för att utveckla företag och anställda
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            Lönesystem som syftar till att stödja både utveckling av företag och anställda kräver att det finns en tydlig beskrivning av hur olika befattningar/flödesgrupper systematiskt bör utvecklas.
                                            I arbetet med att ta fram ett nytt lönesystem är det oftast denna del som är det mest arbetskrävande.
                                        </p>
                                        <p>
                                            Ju tydligare arbetsuppgifter beskrivs, desto enklare blir det att placera in personer i systemet.
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step1-partsgemensamt-arbete"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,overview,partsgemensamt-arbete">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Partsgemensamt arbete
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            Arbetet ska ske partsgemensamt.
                                        </p>
                                        <p>
                                            För att arbetet ska fungera behöver arbetsgivaren och det lokala facket börja med att diskutera sig fram till gemensam plattform för arbetet. De behöver svara på frågorna; Varför, vad och hur?
                                        </p>
                                        <p>
                                            Vad är arbetsgivarens mål med lönesystemet? Vad är det lokala fackets mål? Utifrån detta gäller det att komma fram till gemensam målsättning som sedan får styra arbetet. När det är klart är det dags att ta itu med frågan om vad som behöver göras för att nå dessa mål och hur det ska göras.
                                        </p>
                                        <p>
                                            Några grundläggande frågor är:
                                        </p>
                                        <p>
                                        </p><ul>
                                            <li>Vilka värderingar har vi och hur ser vi på rättvisa?</li>
                                            <li>Vilken arbetsorganisation vill vi ha?</li>
                                            <li>Hur skapar vi möjligheter till utveckling i arbete och lön?</li>
                                            <li>Vad ska påverka lönen?</li>
                                            <li>Hur ska arbetet värderas?</li>
                                            <li>Vilka lönerelationer vill vi ha?</li>
                                        </ul>
                                        <p></p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step1-arbetsgang-bygga-lonesystem"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,overview,arbetsgang">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Arbetsgång för att bygga lönesystem
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            Arbetet med att ta fram ett lönesystem som stöder utveckling av företag och anställda kan schematiskt delas in i följande steg:
                                        </p>
                                        <p>
                                            <img src="/images/IFMetall/Lonesattning_Oversikt_1.png" alt="Förslag till lönesystem">
                                        </p>
                                        <p>
                                            I korthet innehåller de olika stegen följande arbetsmoment:
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Steg 1  Pröva grundläggande värderingar
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Lönesättning handlar om värderingar. Därför är det viktigt att börja med en genomgripande diskussion på företaget om vad rättvisa är och ifall de värderingar som hittills styrt lönesättningen ska gälla också fortsättningsvis.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Steg 2  Analysera dagens lönesättning
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Innan arbetet med ett nytt lönesystem påbörjas, måste vi ta reda på hur lönesättningen i dag fungerar.
                                                        </p>
                                                        <p>
                                                            Fundera över nedanstående frågor:
                                                        </p>
                                                        <p>
                                                        </p><ol>
                                                            <li>Har utveckling i arbetet gett utveckling i lön?</li>
                                                            <li>Bidrar lönesättningen till att utveckla företaget och dess lönsamhet?</li>
                                                            <li>Skapar lönesystemet acceptabla löneskillnader?</li>
                                                            <li>Förstår alla varför de har den lön de har?</li>
                                                            <li>Känner alla till vad som krävs för en bra löneutveckling?</li>
                                                            <li>Fungerar lönesystemet för alla eller har vissa slagit i taket?</li>
                                                        </ol>
                                                        <p></p>
                                                        <p>
                                                            Kort sagt: lever lönesättningen på företaget upp till kollektivavtalets skrivningar om på vilka grunder lönen ska sättas och hur lönesättningen ska gå till?
                                                        </p>
                                                        <p>
                                                            Gör också en löneanalys på arbetsplatsen med hjälp av exempelvis ett enkelt ”plotterdiagram”.
                                                        </p>
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Exempel 1
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Oversikt_2.png">
                                                                    </p>
                                                                    <p>
                                                                        Med stöd av ovanstående diagram kan ni få svar på hur olika grupper ligger till lönemässigt på företaget. Det kan som i exemplet ovan vara kvinnor jämfört med män. Det kan också vara unga jämfört med äldre eller anställda med utländsk bakgrund jämfört med anställda födda i Sverige.
                                                                    </p>
                                                                    <p>
                                                                        Med stöd av denna typ av diagram finns det också underlag för att diskutera andra lönerelationer, exempelvis varför det är så stor skillnad i lön i befattningarna B och C.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Exempel 2
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        En analys av lönesättningen kan också relateras till exempelvis anställningstid. Det exemplifieras i diagrammet nedan. Här ser man att män med cirka tio års anställning har högre lön än såväl män som kvinnor med många fler anställningsår.
                                                                    </p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Oversikt_3.png" alt="Lönesättning översikt"><br>
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Exempel 3
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Av nedanstående diagram framgår skillnaderna mellan några män och kvinnor i en befattning, när det gäller hur deras lön fördelas mellan grundlön, befattningslönedel (BLD), individuell lönedel (ILD) och rörlig löndel (RLD).
                                                                    </p>
                                                                    <p>
                                                                        Här ser vi att nästan alla män (M) har en bättre utveckling än kvinnorna (Kv), när det gäller befattningslönedelen. Frågan blir då vad det beror på.
                                                                    </p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Oversikt_4.png">
                                                                    </p>
                                                                    <p>
                                                                        Alla dessa analyser kan göras också utifrån andra variabler än kön, exempelvis ålder eller produktionsenhet.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Lönekartläggning
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Var tredje år ska alla företag göra en lönekartläggning, utifrån diskrimineringslagens krav.
                                                                    </p>
                                                                    <p>
                                                                        De avgörande skillnaderna mellan en löneanalys enligt kollektivavtalet och lönekartläggning enligt diskrimineringslagen är:
                                                                    </p>
                                                                    <p>
                                                                    </p><ul style="list-style-image:url('../gfx/dash.png');">
                                                                        <li>att löneanalys endast omfattar befattningar inom det egna kollektivavtalsområdet, medan lönekartläggningen jämför lönerelationerna också över avtalsgränserna</li>
                                                                        <li>att löneanalysen fokuserar på alla slags osakliga löneskillnader, inte bara osakliga löneskillnader relaterat till kön</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        Både för Teknikavtalet IF Metall och för avtalen inom Industri- och Kemigruppens område har partsgemensamt material tagits fram som stöd i lönekartläggningen.
                                                                    </p>
                                                                    <p>
                                                                        IF Metall har dessutom tagit fram ett handledningsmaterial för både jämställdhetsplan och handlingsplan för jämställda löner.
                                                                    </p>
                                                                    <p>
                                                                        Materialen finns på medlemsportalen.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Steg 3  Forma en bra arbetsorganisation
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Arbetet med att beskriva och utveckla befattningarna finns beskrivet inom området Arbetsorganisation. Arbetet innebär i korthet:
                                                        </p>
                                                        <p>
                                                        </p><ul>
                                                            <li>beskriva och utveckla befattningar</li>
                                                            <li>skapa grund och utvecklingsblock i alla befattningar</li>
                                                        </ul>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Steg 4  Ta ställning till vad som ska påverka lönen
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Lönen kan sättas på olika grunder. Kraven i arbetet är den viktigaste utgångspunkten för lönesättningen. Det kan då handla om vilket ansvar som ligger i arbetet, vilken skicklighet det kräver eller hur hårt det är. Men också andra faktorer kan tas med i bedömningen, som vilka meriter de anställda har, hur de utför arbetet och företagets resultat.
                                                        </p>
                                                        <p>
                                                            Lönen kan alltså grundas på olika typer av faktorer och dessa kan ha olika syften. Det är därför praktiskt att dela in lönen i olika lönedelar – med utgångspunkt från varje lönedels roll i utvecklingen på företaget och vad den grundas på.
                                                        </p>
                                                        <p>
                                                            De begrepp som vi brukar använda är:
                                                        </p><ul>
                                                            <li>Grundlönedel.</li>
                                                            <li>Befattningslönedel.</li>
                                                            <li>Individuell lönedel.</li>
                                                            <li>Rörlig lönedel.</li>
                                                        </ul>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Steg 5  Konstruera lönesystemet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Lönesystemen kan bestå av högst fyra olika lönedelar. I detta avsnitt beskriver vi olika metoder för att konstruera respektive lönedel. Den enda lönedelen som finns med i alla lönesystem är grundlönedelen. Befattningslönedelen fångar upp utvecklingen i arbetet. Övriga lönedelar är tillval. Mer om detta finns också under ”Löneteknisk stapel”.
                                                        </p>
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Värdera arbetet – grundlön
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Grundlönedelen och befattningslönedelen baseras på kraven i arbetet. En viktig del i lönesättningen är därför att värdera dessa krav.
                                                                    </p>
                                                                    <p>
                                                                        Vanliga faktorer för att bedöma arbetets krav är:
                                                                    </p><ul>
                                                                        <li>Krav på skicklighet i arbetet (teoretisk eller praktisk kunskap).</li>
                                                                        <li>Vilket ansvar som ingår.</li>
                                                                        <li>Hur ansträngande arbetet är.</li>
                                                                        <li>Belastningen i miljön.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Värdera arbetaren – individuell lönedel
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Den individuella lönedelen har i mångas öron en negativ klang. Man befarar att anställda lämnas ut åt chefens godtycke. Men det behöver inte vara på det sättet. Det beror på vilka faktorer den individuella lönedelen bygger på och hur tydligt bedömningsgrunderna är formulerade.
                                                                    </p>
                                                                    <p>
                                                                        Grovt kan de individuella lönefaktorerna indelas i tre grupper.
                                                                    </p>
                                                                    <p>
                                                                    </p><ul>
                                                                        <li>Värdering utifrån den anställdas <i>meriter</i> kopplat till arbetet, t.ex. anställningstid, utbildning, erfarenhet eller mångkunnighet.</li>
                                                                        <li>Värdering utifrån <i>hur den anställda utför</i> arbetet, t.ex. snabbhet i arbetet, kvalitet, problemlösning eller självständighet.</li>
                                                                        <li>Värdering utifrån den anställdas <i>egenskaper</i>, t.ex. samarbetsförmåga eller social kompetens.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        <strong>Kollektivavtalet</strong>
                                                                    </p>
                                                                    <p>
                                                                        En utgångspunkt i arbetet med den individuella lönedelen är de skrivningar som finns i våra kollektivavtal om vad lönen ska grundas på.
                                                                        I exempelvis Teknikavtalet IF Metall skrivs uttryckligen att <i>”löneskillnader ska vara objektivt och väl motiverade”</i> och att
                                                                        <i>”varje medarbetare ska veta på vilka grunder lönen satts och vad medarbetaren kan göra för att öka lönen.”</i>
                                                                    </p>
                                                                    <p>
                                                                        En annan utgångspunkt är att de valda lönefaktorerna ska vara meningsfulla.
                                                                    </p>
                                                                    <p>
                                                                        Några frågor som bör ställas i arbetet med att välja lönefaktorer är därför:
                                                                    </p>
                                                                    <p>
                                                                    </p><ul>
                                                                        <li>Upplevs den föreslagna lönefaktorn som rättvis?</li>
                                                                        <li>Ger den utveckling i arbete och lön för medlemmarna?</li>
                                                                        <li>Är den en bra utgångspunkt för löneskillnaderna på arbetsplatsen?</li>
                                                                        <li>Bidrar den till företagets lönsamhet?</li>
                                                                    </ul>
                                                                    <p></p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Rörlig lönedel
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Den rörliga lönedelen syftar till att fånga upp prestationen i mätbara termer.
                                                                    </p>
                                                                    <p>
                                                                        Ibland uppfattas den positivt, då den ger de anställda möjlighet att påverka sin lön. Ibland uppfattas den negativt. Det kan då bero på att lönefaktorerna utformats så att de blir ett hinder för att utveckla arbetsorganisationen. De kan exempelvis hämma samarbetet i gruppen om de mäts på individnivå. De kan också uppmuntra till onödig specialisering eller för hög arbetstakt, med risk för arbetsskador.
                                                                    </p>
                                                                    <p>
                                                                        På samma sätt som vid valet av övriga lönefaktorer, bör man i diskussionen om eventuella rörliga lönedelar alltid ställa frågan: Vad vill vi uppnå? Vad ska denna lönedel styra mot?
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Steg 6  Placera in de anställda i lönesystemet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            När lönesystemet är färdigbyggt är det dags att göra ett första försök att placera in de anställda i systemet. Det blir ett test på hur det fungerar i praktiken.
                                                        </p>
                                                        <p>
                                                        </p><ul>
                                                            <li>Är arbetsbeskrivningarna för grundbefattningar och utvecklingsblock tydliga? Är det enkelt att placera in de anställda?</li>
                                                            <li>Om det finns en individuell lönedel; är lönefaktorerna tillräckligt definierade? Finns det exempel som gör att alla förstår vad som krävs?</li>
                                                            <li>Om det finns rörlig lönedel; fungerar den som tänkt i praktisk tillämpning?</li>
                                                            <li>Vilka möjligheter till utveckling i arbete och lön finns kvar i lönesystemet när alla är inplacerade?</li>
                                                        </ul>
                                                        <p></p>
                                                        <p>
                                                            Provinplacering är ett bra sätt att upptäcka eventuella brister i systemet. I ett väl genomarbetat system ska det gå snabbt att se vilken grundlön varje anställd ska ha, vilket befattningstillägg, vad en eventuell individuell lönedel ger och inom vilket spann en eventuell rörlig lönedel rör sig.
                                                        </p>
                                                        <p>
                                                            Det är viktigt att de anställda hamnar rätt vid inplaceringen och att det finns kvar utvecklingsmöjligheter för alla i lönesystemet.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Steg 7  Ta ställning till önskade relationer mellan lönedelarna
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Vilken betydelse ska då de olika lönedelarna ha för den totala lönen?
                                                        </p>
                                                        <p>
                                                            För att kunna göra den typen av överväganden behöver ni ha en bild av hur den nuvarande lönesättningen ser ut.
                                                        </p>
                                                        <p>
                                                        </p><ul>
                                                            <li>Hur stor del av lönen utgörs av grundlön?</li>
                                                            <li>Hur stor del är kopplad till de anställdas utveckling i befattningen?</li>
                                                            <li>Om det finns individuella och rörliga lönedelar, hur stora är de i förhållande till grundlön och befattningslönedel?</li>
                                                        </ul>
                                                        <p></p>
                                                        <p>
                                                            Kanske finns det ingen klar uppdelning i lönedelar i dagens lönesättning, men med stöd av lönestapeln blir det snart tydligt vad som är vad.
                                                        </p>
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Löneskillnader i första hand utifrån arbetsinnehåll
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        En rekommendation är att löneskillnaderna i första hand ska bygga på arbetsinnehållet. Grundlönedelen och befattningslönedelen ska svara för den dominerande delen av lönen. Denna fokusering på arbetets innehåll är en av skillnaderna mellan arbetar- och tjänstemannaavtal.
                                                                    </p>
                                                                    <p>
                                                                        <em>Befattningslönedelen</em> bör vara tillräckligt stor för att motivera arbetstagarna att utveckla sig i arbetet
                                                                    </p>
                                                                    <p>
                                                                        Den <em>individuella lönedelen</em> bidrar inte till att utveckla arbetsorganisationen, då den är relaterad till individen och inte till arbetsuppgifterna. Den bör därför vara en mindre del av den totala lönen. Hur stor del beror förstås på typen av befattning.
                                                                    </p>
                                                                    <p>
                                                                        Den <em>rörliga lönedelen</em> får inte vara så stor att den hotar befattningsutvecklingen. Det ska finnas större möjlighet till löneutveckling genom befattningslönedelen än genom den rörliga lönedelen.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Löneskillnader som bidrar till utveckling
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        En utgångspunkt i arbetet med det nya lönesystemet är att löneskillnaderna ska bidra till utveckling av anställda och företag.
                                                                    </p>
                                                                    <p>
                                                                        Ett sätt att tydliggöra lönesystemets betydelse som drivkraft för utveckling kan vara att räkna fram vilken inverkan de olika lönedelarna har på löneskillnaderna på företaget.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Steg 8  Provkör lönesystemet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Innan det nya lönesystemet spikas bör förslaget ”provköras” för att se hur det slår i praktiken. För att kunna testa lönesystemet måste de anställda vara inplacerade och värden ha lagts in på de olika lönedelarna i systemet (grundbefattningar, utvecklingsblock samt eventuella individuella respektive rörliga lönefaktorer).
                                                        </p>
                                                        <p>
                                                            Med hjälp av provinplaceringen går det att pröva sig fram till vilka prislappar som ger rimliga löneskillnader. Här kommer också övervägandena om lönedelarnas inbördes relationer in. Målet är ju att lönesystemet ska bidra till utveckling av anställda och därmed till ett mer konkurrenskraftigt företag.
                                                        </p>
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Gör en löneanalys av det nya systemet
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Genom att provköra systemet ser ni vilken lön de anställda får i det nya lönesystemet jämfört med det gamla.
                                                                    </p>
                                                                    <p>
                                                                        Ni kan pröva förslaget till nytt lönesystem utifrån i princip samma frågor som ni ställde när det gällde det gamla lönesystemet.
                                                                    </p>
                                                                    <p>
                                                                    </p><ol>
                                                                        <li>Ger utveckling i arbetet också utveckling i lön?</li>
                                                                        <li>Bidrar lönesättningen till att utveckla företaget och dess lönsamhet?</li>
                                                                        <li>Skapar lönesystemet rimliga löneskillnader?</li>
                                                                        <li>Blir det förståeligt för alla varför de har den lön de har?</li>
                                                                        <li>Är det klart vad som krävs för en bra löneutveckling?</li>
                                                                        <li>Fungerar lönesystemet för alla eller kommer vissa att slå i taket inom kort?</li>
                                                                        <li>Uppfyller förslaget de mål som parterna satte upp för det nya lönesystemet? Styr det åt rätt håll?</li>
                                                                    </ol>
                                                                    <p></p>
                                                                    <p>
                                                                        Utifrån denna kan ni bedöma hur förslaget till nytt lönesystem slår för enskilda befattningar och mellan olika grupper. Det kan handla om att jämföra kvinnodominerade grupper med mansdominerade, yngre med äldre eller anställda med utländsk bakgrund med anställda som är födda i Sverige.
                                                                    </p>
                                                                    <p>
                                                                        Gå slutligen igenom förslaget med en grupp medlemmar. Är det nya förslaget till lönesystem förståelig? Känns det acceptabelt? Är lönefaktorerna begripliga?
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Rätta till bristerna
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Efter att räknat på hur lönesystemet slår och testat hur medlemmar uppfattar det kan ni rätta till de brister ni hittat.
                                                                    </p>
                                                                    <p>
                                                                    </p><ul>
                                                                        <li>Kanske ligger lönenivån för kvinnorna lägre än för männen. Beror det på att värderingarna i lönesystemet fortfarande gynnar arbetsuppgifter som utförs av män? Då kan det finnas skäl att pröva värderingarna ett varv till.</li>
                                                                        <li>Har de kvinnodominerade befattningarna mindre utvecklingsmöjligheter och färre kvalificerade/välbetalda arbetsuppgifter? Se i så fall över befattningarna ännu en gång med stöd av Systematisk befattningsbeskrivning.</li>
                                                                        <li>Kanske kommer några redan inom ett par år att slå i taket. Se över möjligheterna till utveckling.</li>
                                                                        <li>Upplevs lönefaktorerna som luddiga. Beskriv tydligare, ge exempel.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        När detta är gjort har ni en struktur med grundbefattningar och utvecklingsblock. Ni har arbetat fram förslag på vilka relationer det ska vara mellan de olika lönedelarna och vilket värde de olika delarna i lönesystemet ska ha.
                                                                    </p>
                                                                    <p>
                                                                        Avslutningsvis. Försök inte att till varje pris pressa in alla befattningar i samma lönesystem. Om någon grupp skiljer sig för mycket från övriga, gör hellre en egen lösning för dem. Denna ska förstås bygga på samma löneprinciper.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    VERKTYGET – LOKALT REGELVERK
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <common-rule v-bind:disabled="writeoverview == false" regulationtype="1"></common-rule>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>
                <div v-if="hidesalarysteps == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 2}" @click="step = 2">
                        <span v-html="'Lönestapel'"></span>
                    </div>
                </div>
                <div v-if="step == 2" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step2-beskrivning-lonestapeln"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,salary-ladder,concepts">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Beskrivning av lönestapeln
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded" data-manual-info-body>
                                    <div class="pt-2 pb-4 col-md-7">
                                        <p>
                                            Ett lönesystem kan bestå av en eller flera lönedelar. Lönedelarna kan högst vara fyra. Lönedelarna skiljer sig från varandra genom att de skapar löneskillnader på olika grunder.
                                        </p>
                                        <p>
                                            <img src="/images/IFMetall/Lonesattning_Lonestapel_1.png">
                                        </p>
                                        <p>
                                            Det är viktigt att ha i minnet att den lönetekniska stapeln ritad på detta sätt enbart hjälper oss att kategorisera olika lönesystemstyper och har inget med lönenivåer inom de olika delarna att göra.
                                        </p>
                                        <p>
                                            IF Metall har sedan i slutet av 1980-talet arbetat för att industriarbetarnas ska ges rättvisa möjligheter till utveckling i arbete och lön. För att detta ska kunna genomföras i praktiken måste fördelning av arbetsuppgifter och befogenheter mellan befattningar och lönesystemet stödja en sådan utveckling. I detta avseende är därför utveckling av arbetsorganisation kopplat till befattningslönedel centralt.
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step2-if-metall-lonesystem"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,salary-ladder,if-metall">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Hur ser lönesystemen ut inom IF Metall?
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        IF Metall gör kontinuerliga uppföljningar av den lokala lönesättningen. Lönesättningen är en del av undersökningen Industriarbetarnas arbetsvillkor.
                                    </div>

                                    <v-expansion-panels variant="accordion">
                                        <!--
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Andel industriarbetare som omfattas av lönesystem
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            <img src="/images/Lonesattning_Lonestapel_2.png" alt="Lönesättning lönestapel">
                                                        </p>
                                                        <p>
                                                            Under mätperioden har andelen industriarbetare som omfattas av lönesystem minskat med 7 procentenheter. Det bör noteras att på många företag är lönesystemen visserligen uppsagda men de fungerar fortfarande som hjälpmedel för fördelning av pottpengar. Det gäller i synnerhet när lönesystemen sagts upp för att ersättas av ett nytt lönesystem.
                                                        </p>
                                                        <p>
                                                            Andelen industriarbetare som omfattas av lönesystem skiljer sig avsevärt mellan olika avtalsområden. Inom exempelvis Gruv- och  Stål- och metallavtalet samt inom Byggnandsämnesindustrin omfattas i princip alla.
                                                        </p>
                                                        <p>
                                                            Lägst andel industriarbetare som omfattas av lönesystem finns inom Tvätt-, Gemensamma metall- samt Allokemiska avtalet.
                                                        </p>
                                                        <p>
                                                            Andelen industriarbetare som omfattas av lönesystem skiljer sig också i förhållande till företagets storlek. Inom företag med 50–100 industriarbetare omfattas 65 procent av lönesystem, medan alla omfattas av lönesystem i företag med mer än 1000 industriarbetare.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>-->
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Hur är lönesystemen uppbyggda?
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            <img src="/images/Lonesattning_Lonestapel_3.png">
                                                        </p>
                                                        <p>
                                                            Diagrammet visar att andelen industriarbetare som omfattas av befattningslönedel nästan dubblerats sedan mätningen 1994.
                                                        </p>
                                                        <p>
                                                            Befattningslönedelen premierar att befattningar successivt blir bredare. En lika tydlig trend visar att andelen industriarbetare som omfattas av en rörlig lönedel minskat under mätperioden. Det bör noteras att när vi i detta sammanhang har definierat rörliga delar avser vi rörliga lönedelar som betalas månatligen. Det betyder att <em>bonusar</em> som betalas ut exempelvis kvartals-, halvårs- eller årsvis inte omfattas.
                                                        </p>
                                                        <p>
                                                            Befattningslönedelen omfattar högst andel av industriarbetarna inom Gruv-, Byggnadsämnes-, Teko- samt STål- och metallavtalet..
                                                        </p>
                                                        <p>
                                                            Den individuella lönedelen omfattar högst andel industriarbetare inom Gruv-, Motorbransch-, Samhall-, Stål- och metall-  och Tekoavtalet samt inom Byggnadsämnesindustrin.
                                                        </p>
                                                        <p>
                                                            När det gäller rörlig lönedel så ligger Motorbranschavtalet i en klass för sig. Här omfattas 85 procent av industriarbetarna.
                                                        </p>
                                                        <p>
                                                            Sett inom hela IF Metall och utifrån hur stor andel industriarbetare som omfattas är det vanligaste lönesystemet konstruerat av grundlönedel, befattningslönedel och en individuell lönedel.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step2-exempel-lonesystemskonstruktioner"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,salary-ladder,examples">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Exempel på lönesystemskonstruktioner
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        Här redovisar vi två exempel på lönesystem som är relativt vanliga. Systemen är enkla, tydliga, och den enskilde ges möjligheter till att veta på vilka grunder lönen satts och vad han/hon ska göra för att öka lönen.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Det lilla företaget
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Här beskrivs hur ett lönesystem kan se ut på ett litet företag där skillnaderna i befattningar inte är särskilt stora. I detta exempelföretag är produktionen upplagd i två olika processer.
                                                            Dessutom finns det lagerarbete.
                                                        </p>
                                                        <p>
                                                            Man har valt att utforma ett lönesystem med grundlönedel, befattningslönedel och individuell lönedel.
                                                        </p>
                                                        <h4>Grundlön</h4>
                                                        <p>
                                                            Kraven i arbetet för nyanställda är likartade mellan de olika typerna av arbeten som utförs. De lokala parterna har därför enats om att ha samma grundlön för samtliga arbetare.
                                                        </p>
                                                        <h4>Befattningslönedel</h4>
                                                        <p>
                                                            Arbetsuppgifterna i respektive process har definierats och delats in i olika utvecklingsklossar. Vissa utvecklingsklossar har flera svårighetsnivåer.
                                                        </p>
                                                        <p>
                                                            Samtliga utvecklingsklossar har värderats utifrån kravet på normal upplärningstid. Varje upplärningssteg/upplärningsintervall får ett värde (kronor/månad).
                                                        </p>
                                                        <p>
                                                        </p><table border="1" cellspacing="0" style="border-collapse:collapse; border: 1px solid black">
                                                            <tbody>
                                                                <tr><th align="left" style="width: 170px">Upplärningstid</th><th align="left">Kr/mån</th></tr>
                                                                <tr><td>&lt; 3 månader</td><td></td></tr>
                                                                <tr><td>3 - &lt; 6 månader</td><td></td></tr>
                                                                <tr><td>6 - &lt; 9 månader</td><td></td></tr>
                                                                <tr><td>9 - &lt; 12 månader</td><td></td></tr>
                                                                <tr><td>&gt; 12 månader</td><td></td></tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <h4>Individuell lönedel</h4>
                                                        <p>
                                                            Den individuella lönedelen har formats som ett erfarenhetstillägg. Den praktiska erfarenheten värderas utifrån dels antal år inom tillverkningsindustrin, dels anställningstid i företaget. Varje grad får ett värde (kronor/månad).
                                                        </p>
                                                        <p>
                                                        </p><table border="1" cellspacing="0" style="border-collapse:collapse; border: 1px solid black">
                                                            <tbody>
                                                                <tr><th align="left" style="width: 170px">Tid i tillverkningsindustrin / anställningstid</th><th align="left">Kr/mån</th></tr>
                                                                <tr><td>Grad 1: Fr.o.m. 6 mån till 1 år</td><td></td></tr>
                                                                <tr><td>Grad 2: Fr.o.m. 1 år till 3 år</td><td></td></tr>
                                                                <tr><td>Grad 3: Fr.o.m 3 år till 5 år</td><td></td></tr>
                                                                <tr><td>Grad 4: Fr.o.m 5 år till 7 år</td><td></td></tr>
                                                                <tr><td>Grad 5: Fr.o.m 7 år</td><td></td></tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <h4>Kompetensmatris</h4>
                                                        <p>
                                                            För grundbefattningen och de olika utvecklingsklossarna anges också kompetenskrav.
                                                        </p>
                                                        <p>
                                                            Med stöd av detta tas en kompetensmatris fram för hela företaget: vilka krav på kompetens finns i arbetet, vilken kompetens har de anställda redan idag och vilken ytterligare kompetens behövs?
                                                        </p>
                                                        <h4>Systemskiss</h4>
                                                        <p>
                                                            Detta lönesystem kan åskådliggöras på nedanstående sätt.
                                                        </p>
                                                        <p>
                                                            <img src="/images/Lonesattning_Lonestapel_4.png">
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Det lite större företaget
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Här beskrivs hur ett lönesystem kan se ut på ett lite större företag. I detta exempel används grundlönedel, befattningslönedel, individuell lönedel och rörlig lönedel.
                                                        </p>
                                                        <h4>Grundlönen</h4>
                                                        <p>
                                                            Grundlönen baseras på arbetsvärdering utifrån faktorerna Kunskaper och färdigheter, Ansvar, Ansträngning och Arbetsförhållanden.
                                                        </p>
                                                        <p>
                                                            Utifrån den gjorda värderingen har fem olika grundlönegrupper skapats, där varje befattning har sin grundlön.
                                                        </p>
                                                        <p>
                                                        </p><table border="1" cellspacing="0" style="border-collapse:collapse; border: 1px solid black">
                                                            <tbody>
                                                                <tr><th align="left" style="width: 170px">Grupp</th><th align="left">Kr/mån</th></tr>
                                                                <tr><td>Grupp 1: Lager</td><td></td></tr>
                                                                <tr><td>Grupp 2: Montering detaljer samt Logistik</td><td></td></tr>
                                                                <tr><td>Grupp 3: Slutmontering</td><td></td></tr>
                                                                <tr><td>Grupp 4: Bearbetning</td><td></td></tr>
                                                                <tr><td>Grupp 5: Underhåll samt Verktygsmakare</td><td></td></tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <h4>Befattningslönedelen</h4>
                                                        <p>
                                                            För varje grupp har tre fördjupningsområden skapats.
                                                        </p>
                                                        <p>
                                                            Samtliga anställda har rätt att lära sig fördjupning till nivå 3 inom respektive grupp. Därefter finns möjlighet att lära sig arbetsuppgifter inom ytterligare tre områden:
                                                        </p>
                                                        <p>
                                                        </p><ol>
                                                            <li>processtekniker</li>
                                                            <li>gruppsamordnare</li>
                                                            <li>kvalitetsansvarig</li>
                                                        </ol>
                                                        <p></p>
                                                        <p>
                                                            De olika utvecklingsblocken har fått sitt värde utifrån hur lång tid det tar i ett normalfall att lära sig ett nytt utvecklingsblock. Följande skala är framförhandlad:
                                                        </p>
                                                        <p>
                                                        </p><table border="1" cellspacing="0" style="border-collapse:collapse; border: 1px solid black">
                                                            <tbody>
                                                                <tr><th align="left" style="width: 170px">Upplärningstid</th><th align="left">Kr/mån</th></tr>
                                                                <tr><td>Mindre än 3 månader</td><td></td></tr>
                                                                <tr><td>Fr.o.m. 3 till 6 månader</td><td></td></tr>
                                                                <tr><td>Fr.o.m 6–till 12 månader</td><td></td></tr>
                                                                <tr><td>Fr.o.m 12 månader</td><td></td></tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <h4>Individuell lönedel</h4>
                                                        <p>
                                                            Som individuell lönedel har man valt ett erfarenhetstillägg och ett mångkunnighetstillägg.
                                                        </p>
                                                        <h4>Erfarenhetstillägg</h4>
                                                        <p>
                                                            Den praktiska erfarenheten värderas utifrån antal år inom tillverkningsindustrin.
                                                        </p>
                                                        <p>
                                                        </p><table border="1" cellspacing="0" style="border-collapse:collapse; border: 1px solid black">
                                                            <tbody>
                                                                <tr><th align="left" style="width: 170px">Tid i tillverkningsindustrin</th><th align="left">Kr/mån</th></tr>
                                                                <tr><td>Grad 1: Fr.o.m. 6 mån till 1 år</td><td></td></tr>
                                                                <tr><td>Grad 2: Fr.o.m. 1 år till 3 år</td><td></td></tr>
                                                                <tr><td>Grad 3: Fr.o.m 3 år till 5 år</td><td></td></tr>
                                                                <tr><td>Grad 4: Fr.o.m 5 år</td><td></td></tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <h4>Anställningstidstillägg</h4>
                                                        <p>
                                                            I detta exempel har man också lagt in ett tillägg relaterat till anställningstid på företaget, som ett sätt att behålla kompetent arbetskraft.
                                                        </p>
                                                        <p>
                                                        </p><table border="1" cellspacing="0" style="border-collapse:collapse; border: 1px solid black">
                                                            <tbody>
                                                                <tr><th align="left" style="width: 170px">Tid i tillverkningsindustrin</th><th align="left">Kr/mån</th></tr>
                                                                <tr><td>Grad 1: Fr.o.m. 6 mån till 1 år</td><td></td></tr>
                                                                <tr><td>Grad 2: Fr.o.m. 1 år till 3 år</td><td></td></tr>
                                                                <tr><td>Grad 3: Fr.o.m 3 år till 5 år</td><td></td></tr>
                                                                <tr><td>Grad 4: Fr.o.m 5 år</td><td></td></tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <h4>Mångkunnighetstillägg</h4>
                                                        <p>
                                                            En definition av lönefaktorn Mångkunnighet har gjorts: <em>”att vid behov utföra arbetsuppgifter inom andra flöden”</em>.
                                                        </p>
                                                        <p>
                                                            Grad 1 motsvarar då ett mångkunnighetstillägg, grad 2 motsvarar två mångkunnighetstillägg etc.
                                                        </p>
                                                        <h4>Rörlig lönedel</h4>
                                                        <p>
                                                            I lönesystemet finns också en kvalitetsbonus, som beräknas på respektive flöde.
                                                        </p>
                                                        <h4>Systemskiss</h4>
                                                        <p>
                                                            Detta lönesystem kan åskådliggöras på nedanstående sätt.
                                                        </p>
                                                        <p>
                                                            <img src="/images/Lonesattning_Lonestapel_5.png">
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hideevaluatebasework == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 3}" @click="step = 3">
                        <span v-html="'Värdera grundarbetet'"></span>
                    </div>
                </div>
                <div v-if="step == 3" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">

                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step3-vad-ar-arbetsvardering"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,basework,arbetsvardering">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Vad är arbetsvärdering?
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            Arbetsvärdering är en systematisk metod för att fastställa arbetets krav i olika befattningar och ger ett underlag för att bedöma om arbeten som är olika ändå är likvärdiga när man summerar kraven.
                                        </p>
                                        <p>
                                            Vid arbetsvärdering får inte någon som helst hänsyn tas till de personliga kvalifikationer som enskilda anställda har som utför arbetsuppgifterna.
                                        </p>
                                        <p>
                                            Det är viktigt att påpeka att arbetsvärdering inte är någon objektiv vetenskap, utan ett sätt att systematisera och synliggöra värderingar.
                                        </p>
                                        <p>
                                            Systematiska arbetsvärderingssystem bygger på att de är analytiska och är faktorbaserade. De ska på ett enhetligt sätt beskriva och värdera olika arbeten på en arbetsplats utifrån de krav arbetet ställer på arbetstagaren.
                                        </p>
                                        <p>
                                            Hur stor del av lönen som svarar mot arbetets krav och hur stora löneskillnaderna ska vara bestäms av lönepolitiken. Arbetsvärderingssystem är neutrala i förhållande till detta.
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    Hur går arbetet till?
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Värderingskommitté
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Värderingsgruppen/-kommittén fattar beslut om val av värderingssystem. Båda parter ska vara utbildade i det valda arbetsvärderingssystemet och dess tillämpning. Berörda arbetare ska informeras om arbetsvärderingssystemet.
                                                        </p>
                                                        <p>
                                                            Arbetsvärderingarna bör uppdateras årligen, utifrån de förändringar som sker på företaget.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Arbetsvärderingssystem
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            IF Metall har tagit fram arbetsvärderingssystemet BV2000. Systemet finns inlagt som förslag i verktyget Hållbart arbete. Vår rekommendation är att i ett första skede använda detta arbetsvärderingssystem. Finner man lokalt att systemet inte passar kan det anpassas eller kanske bytas ut helt.
                                                        </p>
                                                        <p>
                                                            Det finns också andra arbetsvärderingssystem på marknaden, bland annat BAS och RANG. De skiljer sig från BV2000 främst genom den föreslagna viktningen av de faktorer som är kopplade till belastningar i arbetet. En annan skillnad är att det i dessa system förekommer breda intervall vid beskrivningen av vissa faktorgrader, vilket kräver lokala förtydliganden för att arbetena ska bli rätt värderade.
                                                        </p>
                                                        <p>
                                                            På Diskrimineringsombudsmannens hemsida (<a href="http://www.do.se">www.do.se</a>) finns en beskrivning av olika arbetsvärderingssystem (se under fliken Gamla ombudsmännens material).
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Lokal anpassning
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            När värderingsfaktorer är valda och definitioner gjorts för varje faktorgrad är det dags att ta ställning till vilken tyngd de olika faktorerna ska ha. Ska en faktor ha större betydelse för lönen än andra, då ger man dess gradsteg högre poäng/poängintervall än de andras.
                                                        </p>
                                                        <p>
                                                            I it-stödet Hållbart arbete finns för varje värderingsfaktor en graderingsskala från 1 till 5, med definition och förslag till poäng för varje faktorgrad. För exempelvis delfaktorn Enformighet ser förslaget ut enligt nedan.
                                                        </p><div style="margin-left: 12pt">
                                                            <div><span style="display:inline-block; width:400px; font-weight:bold; border-bottom: 1px solid black;">Enformighet</span><span style="display:inline-block; width:70px; font-weight:bold; border-bottom: 1px solid black;">Grad</span><span style="display:inline-block; width:70px; font-weight:bold; border-bottom: 1px solid black;">Poäng</span></div>
                                                            <div><span style="display:inline-block; width:400px;">Ingen belastning. Arbetet är omväxlande.</span><span style="display:inline-block; width:70px;">1</span><span style="display:inline-block; width:70px;">0</span></div>
                                                            <div><span style="display:inline-block; width:400px;">Liten belastning. Likartat arbete men med möjlighet till variation.</span><span style="display:inline-block; width:70px;">2</span><span style="display:inline-block; width:70px;">3</span></div>
                                                            <div><span style="display:inline-block; width:400px;">Måttlig belastning. Likartat arbete med begränsade variationer i arbetsinnehållet.</span><span style="display:inline-block; width:70px;">3</span><span style="display:inline-block; width:70px;">6</span></div>
                                                            <div><span style="display:inline-block; width:400px;">Besvärande belastning. Arbeten med mycket små variationer i arbetsinnehållet. Arbetet är vanligtvis kortcykligt eller av övervakande karaktär med passivitet under långa perioder.</span><span style="display:inline-block; width:70px;">4</span><span style="display:inline-block; width:70px;">9</span></div>
                                                            <div><span style="display:inline-block; width:400px;">Påfrestande belastning. Arbete som är mycket likartat utan variationi arbetsinnehåll. I regel mycket kortcykligt arbete eller av övervakande karaktär med passivitet under mycket långa perioder.</span><span style="display:inline-block; width:70px;">5</span><span style="display:inline-block; width:70px;">12</span></div>
                                                        </div>
                                                        <p></p>
                                                        <p>
                                                            Bakom den poängsumma som man kommer fram till efter att ha gått igenom varje värderingsfaktor finns alltså en rad avväganden:
                                                        </p><ul style="list-style-image:url('/images/dash.png');">
                                                            <li>hur arbetet har beskrivits</li>
                                                            <li>vilka värderingsfaktorer som använts</li>
                                                            <li>hur de olika graderna för varje faktor definierats</li>
                                                            <li>vilken poäng graderna för respektive faktor tilldelats.</li>
                                                        </ul>
                                                        <p></p>
                                                        Arbetsvärdering är ett sätt att systematisera och synliggöra våra värderingar av kraven i arbetet.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Riktarbeten
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Det kan vara praktiskt att välja ut ett antal typiska befattningar och värdera dem först. Dessa tjänar som referensarbeten vid värderingen av övriga befattningar. Både manliga och kvinnliga befattningar ska ingå bland riktbefattningarna.
                                                        </p>
                                                        <p>
                                                            Med stöd av befintliga arbetsbeskrivningar, egna iakttagelser och samtal med berörda arbetare fastställer gruppen/kommittén poängtal eller poängintervall för varje grad inom respektive värderingsfaktor.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Gör en koll faktor för faktor
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Innan värderingsresultat fastställs slutgiltigt bör en så kallad faktorkontroll göras. Då går man igenom alla befattningar faktor för faktor. Verkar värderingen av en viss delfaktor, som exempelvis enformighet, riktig när alla befattningar jämförs bara utifrån denna?
                                                        </p>
                                                        <p>
                                                            Det är oftast vid faktorkontrollen man upptäcker om ett arbete är felvärderat.
                                                        </p>
                                                        <p>
                                                            En sammanställning bör också göras av hur kvinnor och män fördelas mellan olika befattningar. Syftet är att undvika poängskillnader mellan befattningar som kan kopplas samman med kön.
                                                        </p>
                                                        <p>
                                                            I verktyget Hållbart arbete kan denna typ av analyser tas fram automatiskt.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>

                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step3-jamstalldhetsperspektiv"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,basework,jamstalldhet">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Att tänka på ur jämställdhetsperspektiv
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        En arbetsvärdering är könsneutral om både systemet och värderingsprocessen är fria från både direkt och indirekt diskriminering.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Direkt diskriminering
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Direkt diskriminering definieras enligt diskrimineringslagen:
                                                        </p><blockquote>
                                                            ”Att någon missgynnas genom att behandlas sämre än någon annan behandlats, har behandlats eller skulle ha behandlats i en jämförbar situation, om missgynnandet har samband med kön, könsöverskridande identitet eller uttryck, etnisk tillhörighet, religion eller annan trosuppfattning, funktionshinder, sexuell läggning eller ålder.”
                                                        </blockquote>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Indirekt diskriminering
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Definieras enligt diskrimineringslagen:
                                                        </p><blockquote>
                                                            ”Att någon missgynnas genom tillämpning av en bestämmelse, ett kriterium eller ett förfaringssätt som framstår som könsneutralt men som kan komma att särskilt missgynna personer av visst kön, viss könsöverskridande identitet eller uttryck, viss etnisk tillhörighet, viss religion eller annan trosuppfattning, visst funktionshinder, viss sexuell läggning eller viss ålder, såvida inte bestämmelsen, kriteriet eller förfaringssättet har ett berättigat syfte och de medel som används är lämpliga och nödvändiga för att uppnå syftet.”
                                                        </blockquote>
                                                        <p></p>
                                                        <p>
                                                            I arbetsvärderingsarbetet kan indirekt diskriminering ske om inte hänsyn tas till krav som är vanliga i typiska kvinnojobb medan krav i typiska manliga befattningar beaktas. Ett exempel kan vara att krav på muskelstyrka men inte finmotorik fångas upp av värderingsfaktorerna på en arbetsplats där majoriteten av kvinnor utför montering av smådetaljer och majoriteten av män utför tunga lyft.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Risk för diskriminering
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Direkt eller indirekt könsdiskriminering kan förekomma i olika faser av arbetet med arbetsvärdering.
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                När underlaget samlas in
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Arbetsbeskrivningar måste kritiskt granskas. Alla arbetsuppgifter och andra krav som har betydelse för värderingen måste tas med.
                                                                    </p>
                                                                    <p>
                                                                        Om arbetsbeskrivningar inte utförs systematiskt riskerar befattningar att bli felbedömda. Exempelvis beskriver ofta kvinnor och män sina jobb olika. Kvinnor tenderar att förminska och beskriva i generella termer medan det motsatta gäller för många män.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                När värderingsfaktorer definieras och viktas
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Systemet måste vara uppbyggt så att det täcker in samtliga valda värderingsfaktorer och eventuella underfaktorer.
                                                                    </p>
                                                                    <p>
                                                                        Det finns en bristande balans i systemet om många fler faktorer är hänförliga till det som kännetecknar mansdominerat arbete jämfört med det som kännetecknar traditionellt kvinnligt arbete.
                                                                    </p>
                                                                    <p>
                                                                        Den tyngd som varje faktor/underfaktor har fått i systemet måste också granskas ur könssynpunkt. Det sker genom kontroll av att de faktorer som tilldelats största vikt inte ensidigt gynnar det ena könet.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                När värderingen genomförs
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Tillämpningen måste vara könsneutral. Sker värderingarna i en arbetsvärderingskommitté bör denna vara allsidigt sammansatt och bestå av både kvinnor och män som fått utbildning för uppdraget.
                                                                    </p>
                                                                    <p>
                                                                        Eftersom det är arbetet – inte de personer som utför arbetet – som ska värderas är det viktigt att i värderingsarbetet bortse från vilka personer som har befattningarna som värderas.
                                                                    </p>
                                                                    <p>
                                                                        I den litteratur som finns tillgänglig om könsneutral arbetsvärdering ges vanligen rådet att värdera en faktor i taget för alla arbeten som ska värderas. Detta för att värderingen ska bli så konsekvent som möjligt.
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>


                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step3-maste-man-anvanda-arbetsvardering"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,basework,arbetsvardering">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Måste man använda arbetsvärdering?
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            På mindre arbetsplatser där arbetsmiljön och belastningar i arbetet inte skiljer sig nämnvärt mellan olika befattningar är det vanligt att alla har samma grundlön.
                                        </p>
                                        <p>
                                            Det är även möjligt att hoppa över arbetsvärdering för grundbefattningen om lokala parter kommit överens om detta. Att först värdera ett antal grundbefattningar skapar ett bra underlag för ett sådant beslut.
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>



                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step3-metoder-grundbefattning"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,basework,methods">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Metoder för att värdera arbetets krav i grundbefattningen
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            Värderingen av kraven i arbetet kan ske på tre sätt:
                                        </p><ul style="list-style-image:url('/images/dash.png');">
                                            <li>med systematisk arbetsvärdering</li>
                                            <li>med klassificering</li>
                                            <li>med rangordning.</li>
                                        </ul>
                                        <p></p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Systematisk arbetsvärdering
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Systematisk arbetsvärdering ger underlag för att jämföra kraven i arbetet mellan olika befattningar. Den ger möjlighet att bedöma inte bara om arbeten är lika, utan också om arbeten som är olika ändå är likvärdiga.
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Klassificering
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Vid systematisk arbetsvärdering jämförs befattningarna faktor för faktor. Vid klassificering bedömer man befattningen som helhet.
                                                        </p>
                                                        <p>
                                                            I vissa avtal finns ingrupperingsregler, som kan användas för att klassificera befattningarna. Ett exempel är Teknikavtalet IF Metalls fyra lönegrupper med grupperingsanvisningar (se tim- och ackordslönebilagan).
                                                        </p>
                                                        <p>
                                                            För att underlätta klassificeringen kan man ta fram några typiska ”riktbefattningar”, som sedan de andra befattningarna på företaget jämförs med som stöd för ingrupperingen (större/mindre krav).
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Rangordning
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Parterna kan även rangordna befattningarna efter arbetets krav. Också det ställer krav, om det ska bli en rangordning som de anställda upplever som rättvis. Vad ska påverka rangordningen? Vad gäller om en befattning rankas högt utifrån en aspekt och lågt utifrån en annan?
                                                        </p>
                                                        <p>
                                                            Rangordning är dock enklare än arbetsvärdering, utifrån att vi nöjer oss med att bedöma de inbördes relationerna mellan befattningarna – vi fördjupar oss inte i exakt hur stora skillnaderna är dem emellan.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    VERKTYGET – VÄRDERA GRUNDARBETET
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">
                                        <p>
                                            Arbetsvärdering av grundarbetet bygger på att det finns väldefinierade arbetsuppgifter. Är arbetet inte gjort måste du göra detta först.
                                        </p>
                                        <p>
                                            Det är möjligt att hoppa över arbetsvärdering för grundbefattningar om de lokala parterna är överens om detta. Det gäller exempelvis om man lokalt tillämpar avtalets ingrupperingsregler eller har samma grundlön för alla befattningar.
                                        </p>
                                        <p>
                                            Att först värdera ett antal grundbefattningar skapar ett bra underlag för ett sådant beslut.
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Förslag till värderingsfaktorer/grader/poäng
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Verktyget innehåller ett förslag till faktorer som kan användas vid värdering av grundarbetet. Det är möjligt att byta ut, lägga till eller ta bort en eller flera faktorer samt vikta om. Vår rekommendation är att använda verktygets förslag till faktorer vid en provvärdering och sedan analysera vad som bör förändras innan eventuella förändringar görs.
                                                        </p>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-evaluate-factors v-bind:disabled="writeevaluatebasework == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-evaluate-factors>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Ange riktarbeten
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Det är praktiskt att välja ut ett antal typiska befattningar och värdera dem först. Dessa tjänar som referensarbeten vid värderingen av övriga befattningar. Både manliga och kvinnliga befattningar ska ingå bland riktbefattningarna.
                                                        </p>
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Ange om en befattning ska betraktas som riktarbete.</li>
                                                        </ol>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">

                                                        <wage-positions v-bind:disabled="writeevaluatebasework == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-positions>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Värdera grundarbetet
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att värdera befattningarnas totala arbetsinnehåll.
                                                        </p>
                                                        <p>
                                                            Det totala arbetsinnehållet bedöms med hjälp av de olika värderingsfaktorerna, dess gradbeskrivningar och poäng.
                                                        </p>
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                11 Utbildning
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Faktorn avser krav på teoretiska kunskaper som kan inhämtas i gymnasium, högskola eller motsvarande.
                                                                    </p>
                                                                    <p>
                                                                        Motsvarande kunskap kan i det enskilda fallet ha inhämtats genom praktiskt arbete och/eller genom intern utbildning.
                                                                    </p>
                                                                    <p>
                                                                        Fastställande av kunskapskrav får inte påverkas av utbildningen hos den eller de personer som vid värderingstillfället sysselsätts i arbetet.
                                                                    </p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Grundfaktor11.png">
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                12 Upplärning
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Faktorn avser krav på praktisk erfarenhet uttryckt i den tid som normalt fordras för att lära sig arbetsuppgifterna på ett kvalitativt och kvantitativt riktigt sätt. Värderingen ska ta hänsyn till det handlag, den noggrannhet och den problemlösning som krävs för normalprestation.
                                                                    </p>
                                                                    <p>
                                                                        Det har ingen betydelse för värderingen hur lång tid den person som vid värderingstillfället utför arbetet har haft denna arbetsuppgift.
                                                                    </p>
                                                                    <p>
                                                                        Några definitioner<br>
                                                                    </p><ul>
                                                                        <li>Noggrannhet omfattar krav på omsorg och varsamhet för att hålla fastställda krav. Det kan exempelvis vara att hålla toleranser och göra inpassningar, att hålla ordning, att utföra rätt expediering, att avsyna, att avläsa och protokollföra resultat.</li>
                                                                        <li>Handlag omfattar krav på uppövad förmåga att hantera och handskas med utrustning och material. Det kan exempelvis vara krav på finmotorik, koordination, god samordning av olika muskelfunktioner med syn- och sinnesuttryck, samordning av rörelser.</li>
                                                                        <li>Problemlösning omfattar krav på att identifiera problem i arbetet, bedöma problemens betydelse, att dra slutsatser samt att åtgärda felaktigheter.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Grundfaktor12.png">
                                                                    </p>
                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                21 Ansvar
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Faktorn avser de krav som arbetet ställer på att utföra:
                                                                    </p>
                                                                    <p>
                                                                    </p><ul>
                                                                        <li>
                                                                            Produktionsplanering.<br>
                                                                            Det kan exempelvis vara arbetsuppgifter kopplade till bemanning, produktionsberedning, material- och orderplanering etc.
                                                                        </li>
                                                                        <li>
                                                                            Produktionsuppföljning (volym, kvalitet etc.).<br>
                                                                            Det kan exempelvis vara slutkontroll, uppföljning av kassaktion, kvalitet, produktionsvolym etc.
                                                                        </li>
                                                                        <li>
                                                                            Kontakter och samarbete internt/externt.<br>
                                                                            Det kan exempelvis vara kontakter inom/mellan produktionsgrupp/er, kundkontakter etc.
                                                                        </li>
                                                                        <li>
                                                                            Introduktion och utbildning.<br>
                                                                            Det kan exempelvis vara att visa nyanställd till rätta, lära upp annan person i nya arbetsuppgifter, genomföra utbildning, ge specialistrådgivning etc.
                                                                        </li>
                                                                        <li>
                                                                            Utvecklings- och förbättringsarbete.<br>
                                                                            Det kan exempelvis vara utvecklings- och förbättringsarbete när det gäller arbetsmetoder, system och produkter.
                                                                        </li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        Ibland ställer arbetsuppgifterna i grundarbetet krav på ansvar men ofta förekommer det djupare ansvaret i utvecklingsblocken. Ansvar är därför också en viktig del när utvecklingsblocken ska värderas.
                                                                    </p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Grundfaktor21.png">
                                                                    </p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                31 Miljöbelastning
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">
                                                                    <p>
                                                                        Miljöbelastning tar hänsyn till de obehag arbetets yttre betingelser medför och värderas med hänsyn taget till den typiska miljösituationen enligt följande:
                                                                    </p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Grundfaktor31.png">
                                                                    </p>
                                                                    <p>
                                                                        Vid värdering tas hänsyn till:<br>
                                                                    </p><ul>
                                                                        <li>Buller (t.ex. ljudstyrka, tonhöjd, intermittent störande ljud. Användning av skyddsutrustning ska inte påverka placeringen i grad).</li>
                                                                        <li>Ljusförhållanden (t.ex. otillfredsställande belysning, irriterande ljus, fixering av blick exempelvis avläsning skalor, arbete vid dataskärm, arbete under mikroskop).</li>
                                                                        <li>Temperatur (t.ex. lufttemperatur, värmestrålning, erforderlig klädsel).</li>
                                                                        <li>Smuts (t.ex. förekomsten av sot, rost, spån, olja, kemikalier, svårigheten att göra sig ren, extrem renlighet).</li>
                                                                        <li>Luftföroreningar (t.ex. ånga, rök, gas, damm, svårighet att göra sig ren).</li>
                                                                    </ul>
                                                                    <p></p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                41 Bundenhet
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Faktorn avser graden av <em>bundenhet i arbetet</em>.
                                                                    </p>
                                                                    <p>
                                                                        Med bundenhet menas:<br>
                                                                    </p><ul>
                                                                        <li>Att arbetarens insats och närvaro är nödvändig för att arbetsförloppet ska kunna fortgå utan avbrott eller för att andra arbetare inte ska hindras i sina arbeten. Här avses främst linesarbeten, övervakning av förlopp etc. Arbetet betraktas som bundet även om det finns tillgång till avbytare.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        Vid värdering av bundenhet tas hänsyn till:<br>
                                                                    </p><ul>
                                                                        <li>Möjligheten att åstadkomma buffert eller bufferttid, vilken kan utnyttjas för längre eller kortare avbrott i arbetet. Med buffert avses att viss mängd material, produkter etc. har åtgärdats och köar vid nästföljande bearbetningsstation.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        Med bufferttid avses att ett arbetsmoment avslutats och att viss väntetid uppstår innan nästa arbetsmoment påbörjas.
                                                                    </p>
                                                                    <p>
                                                                        De olika graderna liten, besvärande respektive påfrestande innebär att arbetaren inte ensam kan bestämma när arbetet får avbrytas för pauser. Arbetaren är alltså på något sätt beroende av andra arbetare eller av den tekniska utrustningen.
                                                                    </p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Grundfaktor41.png">
                                                                    </p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                42 Enformighet
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Med enformighet menas:<br>
                                                                    </p><ul>
                                                                        <li>Den påfrestning som monotona arbeten medför. Därmed avses enkla och likartade arbeten med små variationer i innehållet.</li>
                                                                        <li>Grad och poäng ska spegla arbetsinnehållets totala bredd och variation så att väsentliga skillnader i arbetsuppgifterna blir beaktade.</li>
                                                                    </ul>
                                                                    <p></p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Grundfaktor42.png">
                                                                    </p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                51 Arbetstyngd
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Med arbetstyngd menas den kraftutveckling som med hänsyn till tyngd och frekvens erfordras för manuell hantering av exempelvis material, arbetsstycken och verktyg eller för manövrering av spakar, rattar och dylikt. Här bör observeras att ett arbete som utförs i långa arbetsperioder utan möjlighet till muskelåterhämtning är mer fysiskt ansträngande än ett arbete av samma tyngd som utförs i korta arbetsperioder.
                                                                    </p>
                                                                    <p>
                                                                        Andra saker att ta hänsyn till är vikt i kombination med lyftets höjd och arbetsställning. Att arbeta med små muskelgrupper eller ensidiga rörelser kan vara ansträngande även vid små vikter. Arbetstyngden kan också öka på grund av låsta arbetsställningar.
                                                                    </p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Grundfaktor51.png">
                                                                    </p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                52 Arbetsställning
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Den vanligaste förekommande arbetsställningen ska läggas till grund för val av grad och poäng. Om det tidvis förekommer bättre eller sämre arbetsställningar minskas eller ökas poängen med hänsyn till detta.
                                                                    </p>
                                                                    <p>
                                                                        Vid värderingen ska hänsyn tas till om arbetet är sittande, gående eller stående. Dessutom till om arbetet innebär obehaglig böjning, bändning, vridning eller hård fixering.
                                                                    </p>
                                                                    <p>
                                                                        <img src="/images/Lonesattning_Grundfaktor52.png">
                                                                    </p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">
                                                        <wage-evaluate-basework v-bind:disabled="writeevaluatebasework == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-evaluate-basework>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Resultatet – Faktoranalys
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Faktoranalys visar hur de olika befattningarna är rangordnade i förhållande till varandra i respektive faktor och totalt. Faktoranalysen underlättar ett korrekt värderingsarbete.
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-evaluate-analysis v-bind:disabled="writeevaluatebasework == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-evaluate-analysis>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hideevaluatedevelopmentblocks == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 4}" @click="step = 4">
                        <span v-html="'Värdera utvecklingsblock'"></span>
                    </div>
                </div>
                <div v-if="step == 4" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step4-metod-utvecklingsblock"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,development-blocks,method">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Metod för att bedöma utvecklingsblockens svårighetsgrad
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>



                                        <p>
                                            Vi rekommenderar att lokala parter använder sig av normal upplärningstid när de olika utvecklingsblocken vart och ett ska värderas.
                                        </p>
                                        <p>
                                            Med normal upplärningstid avses den tid det normalt tar att lära sig att utföra arbetet till:
                                        </p><ul>
                                            <li>önskad kvantitet och kvalitet och utifrån fastställda krav på:</li>
                                            <ul style="list-style-image:url('/images/dash.png');">
                                                <li>noggrannhet och handlag</li>
                                                <li>problemlösning.</li>
                                            </ul>
                                        </ul>
                                        <p></p>
                                        <p>
                                            I tabellen nedan finns exempel på en skala för normal upplärningstid.
                                        </p>
                                        <p>
                                        </p><table border="1" class="table-solid-border" cellspacing="0" style="border-collapse:collapse; border: 1px solid black">
                                            <tbody>
                                                <tr><th align="left" style="width: 180px">Normal upplärningstid</th><th align="left">Poäng/kr</th></tr>
                                                <tr><td>Mindre än 3 månader</td><td></td></tr>
                                                <tr><td>Fr.o.m. 3-6 månader</td><td></td></tr>
                                                <tr><td>Fr.o.m. ½-1 år</td><td></td></tr>
                                                <tr><td>Fr.o.m. 1-2 år</td><td></td></tr>
                                                <tr><td>Mer än 2 år</td><td></td></tr>
                                            </tbody>
                                        </table>
                                        <p></p>



                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    VERKTYGET – VÄRDERA UTVECKLINGSBLOCK
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Skapa grader för att värdera utvecklingsblockens svårighetsgrad
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att värdera respektive utvecklingsblocks svårighetsgrad.
                                                        </p>
                                                        <p>
                                                            Faktorn som används är normal upplärningstid och är uppbyggd utifrån hur lång tid det tar för en person i ett normalfall att lära sig utvecklingsblockets arbetsuppgifter till rätt kvalitet och kvalitet utifrån fastställda krav på noggrannhet, handlag, problemlösning och ansvar.
                                                        </p>
                                                        <p>
                                                            Det är möjligt att ändra tidsgränser, poäng  och lägga till ytterligare grader. Vår rekommendation är att använda verktygets förslag vid en provvärdering och sedan analysera resultatet innan förändringar görs.
                                                        </p>


                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Normal upplärningstid
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Med normal upplärningstid avses krav på praktisk erfarenhet uttryckt i den tid som normalt fordras för att lära sig arbetsuppgifterna på ett kvalitativt och kvantitativt riktigt sätt.
                                                                        Värderingen ska ta hänsyn till krav på handlag, noggrannhet, problemlösning och ansvar.
                                                                        Det har ingen betydelse för värderingen hur lång tid den person som vid värderingstillfället utför arbetet har haft denna arbetsuppgift.
                                                                    </p>
                                                                    <p>
                                                                        Några definitioner:
                                                                    </p>
                                                                    <p>
                                                                    </p><ul>
                                                                        <li><i>Noggrannhet</i> omfattar krav på omsorg och varsamhet för att hålla fastställda krav. Det kan exempelvis vara att hålla toleranser och göra inpassningar, att hålla ordning, att utföra rätt expediering, att avsyna, att avläsa och protokollföra resultat.</li>
                                                                        <li><i>Handlag</i> omfattar krav på uppövad förmåga att hantera och handskas med utrustning och material. Det kan exempelvis vara krav på finmotorik, koordination, god samordning av olika muskelfunktioner med syn- och sinnesuttryck, samordning av rörelser.</li>
                                                                        <li><i>Problemlösning</i> omfattar krav på att identifiera problem i arbetet, bedöma problemens betydelse, att dra slutsatser samt att åtgärda felaktigheter.</li>
                                                                        <li>
                                                                            <i>Ansvar</i> avser de krav som arbetet ställer på att utföra:
                                                                            <ul>
                                                                                <li>
                                                                                    Produktionsplanering.<br>
                                                                                    Det kan exempelvis vara arbetsuppgifter kopplade till bemanning, produktionsberedning, material- och orderplanering etc.
                                                                                </li>
                                                                                <li>
                                                                                    Produktionsuppföljning.<br>
                                                                                    Det kan exempelvis vara slutkontroll, uppföljning av kassaktion, kvalitet, produktionsvolym etc.
                                                                                </li>
                                                                                <li>
                                                                                    Kontakter och samarbete internt/externt <br>
                                                                                    Det kan exempelvis vara kontakter inom/mellan produktionsgrupp/er, kundkontakter etc.
                                                                                </li>
                                                                                <li>
                                                                                    Introduktion och utbildning.<br>
                                                                                    Det kan exempelvis vara att visa nyanställd till rätta, lära upp   annan person i nya arbetsuppgifter, genomföra utbildning, ge specialistrådgivning etc.
                                                                                </li>
                                                                                <li>
                                                                                    Utvecklings- och förbättringsarbete.<br>
                                                                                    Det kan exempelvis vara utvecklings- förbättringsarbete när det gäller arbetsmetoder, system och produkter.
                                                                                </li>
                                                                            </ul>
                                                                        </li>
                                                                    </ul>
                                                                    <p></p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">
                                                        <wage-block-dificulty-level v-bind:disabled="writeevaluatedevelopmentblocks == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-block-dificulty-level>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Värdera utvecklingsblock
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p>
                                                        <p>
                                                        </p><ol>
                                                            <li>Välja befattning.</li>
                                                            <li>Värdera utvecklingsblock i respektive befattning.</li>
                                                        </ol>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-block-dificulty-level-evaluation v-bind:disabled="writeevaluatedevelopmentblocks == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-block-dificulty-level-evaluation>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Resultatet – Blockanalys
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        Blockanalysen visar de olika blockens svårighetsgrad inom de olika befattningarna samt det totala antalet poäng inom respektive befattning.
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-block-dificulty-level-analysis v-bind:disabled="writeevaluatedevelopmentblocks == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-block-dificulty-level-analysis>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hideindividualaddons == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 5}" @click="step = 5">
                        <span v-html="'Individuella tillägg'"></span>
                    </div>
                </div>
                <div v-if="step == 5" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step5-for-och-nackdelar-individuella"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,individual-addons,policy">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    För- och nackdelar med individuella tillägg
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        Beroende på vilka individuella tillägg man använder och hur de utformas finns det både för- och nackdelar med individuella till sett ur både ett utvecklings- och saklighetsperspektiv.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Meriter
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">



                                                        <p>
                                                            Meriter som lönefaktorer ställer oftast inte till några större problem. Det är lätt att bedöma om en person har en viss erfarenhet eller utbildning, det skapar inga bedömningstvister. Meriter som lönefaktorer kan därmed sägas vara neutrala i förhållande till arbetsorganisatorisk utveckling, de varken stödjer eller motverkar den.
                                                        </p>
                                                        <p>
                                                            Frågan är dock om de är meningsfulla. Några frågor som bör ställas är:
                                                        </p><ul>
                                                            <li>Upplevs den föreslagna lönefaktorn som rättvis?</li>
                                                            <li>Ger den utveckling i arbete och lön för medlemmarna?</li>
                                                            <li>Är den en bra utgångspunkt för löneskillnaderna på arbetsplatsen?</li>
                                                            <li>Bidrar den till företagets lönsamhet?</li>
                                                        </ul>
                                                        <p></p>
                                                        <p>
                                                            I stället för att beskriva vilka meriter personen som utför en viss arbetsuppgift har, kan man definiera vilka meriter som krävs för uppgiften ifråga. Då ger det utslag i grundlönedelen eller befattningslönedelen, i stället för i den individuella lönedelen.
                                                        </p>



                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Den anställdas egenskaper och sättet att utföra arbetet på
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">



                                                        <p>
                                                            Om sättet att utföra arbetet på ska styra vilken lön som betalas, då måste det vara tydligt hur det ska bedömas. Dessutom måste det vara faktorer som den anställda kan påverka.
                                                        </p>
                                                        <p>
                                                            Särskilt problematiska är de lönefaktorer som har med den anställdas <em>egenskaper</em> att göra. Om den individuella lönedelen bygger på lönefaktorer som samarbetsförmåga eller kreativitet – då hamnar vi i träsklandet av subjektiva bedömningar, med risk för att anställda känner sig orättvist behandlade. Detta kan försämra samarbetet på företaget och inverka negativt på viljan till utveckling.
                                                        </p>
                                                        <p>
                                                            Subjektiva lönefaktorer kan omformas till befattningslönedelar. Då beskriver man i stället arbetsuppgifter som förutsätter ett visst förhållningssätt eller en viss egenskap, exempelvis samarbetsförmåga. Därmed kommer man undan de risker som finns med alltför ”svampiga” lönefaktorer.
                                                        </p>
                                                        <p>
                                                            Då subjektiva lönefaktorer används måste de hanteras med omsorg. Bedömningarna kan exempelvis bygga på synpunkter från fler än chefen och sedan föredras i en partssammansatt lönekommitté.
                                                        </p>
                                                        <p>
                                                            En rekommendation när det gäller den individuella lönedelen är att:
                                                        </p>
                                                        <p>
                                                        </p><ul style="list-style-image:url('/images/dash.png');">
                                                            <li>använda få lönefaktorer (helst inte fler än tre)</li>
                                                            <li>i första hand välja faktorer som bygger på objektiva bedömningar</li>
                                                            <li>bara välja faktorer som de anställda kan påverka</li>
                                                            <li>vara tydlig med vad respektive faktor avser (gärna exempel)</li>
                                                            <li>göra tydliga avgränsningar mellan varje faktorgrad</li>
                                                            <li>om subjektiva kriterier ändå används, se till att fler blandas in i bedömningen så att underlaget för värderingen breddas.</li>
                                                        </ul>
                                                        <p></p>



                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step5-vardering-egenskaper"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,individual-addons,criteria">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Vid värdering av arbetarnas egenskaper eller av hur arbetet utförs
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            För att individen ska kunna veta på vilka grunder lönen har satts och vad han/hon kan göra för att höja sin lön krävs att både värderingsfaktorer och grader är väldefinierade, att de är tydliga och konkreta. Detta gäller också då man använder värderingsfaktorer som tar fasta på hur de anställda utför arbetet eller de anställdas egenskaper.
                                        </p>
                                        <p>
                                            Nedan ges exempel på en mindre väl definierad värderingsfaktor – och på bättre.
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Krav och förväntningar måste beskrivas
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">



                                                        <p>
                                                            Ibland används faktorer som handlar om att individen ska bedömas utifrån hur kraven i arbetet uppfylls. Det kan se ut som exemplet nedan visar:
                                                        </p>
                                                        <p>
                                                        </p><table class="table-solid-border" border="1" cellspacing="0" style="border-collapse:collapse; border: 1px solid black">
                                                            <tbody>
                                                                <tr>
                                                                    <th style="font-style:italic; text-align:left; font-weight: normal; width: 100px">Faktor</th>
                                                                    <th style="font-style:italic; text-align:left; font-weight: normal; width: 100px">Grad 1. Motsvarar inte alls kraven</th>
                                                                    <th style="font-style:italic; text-align:left; font-weight: normal; width: 100px">Grad 2. Motsvarar kraven dåligt</th>
                                                                    <th style="font-style:italic; text-align:left; font-weight: normal; width: 100px">Grad 3. Motsvarar kraven </th>
                                                                    <th style="font-style:italic; text-align:left; font-weight: normal; width: 100px">Grad 4. Överträffar kraven</th>
                                                                    <th style="font-style:italic; text-align:left; font-weight: normal; width: 100px">Grad 5. Överträffar kraven klart</th>
                                                                </tr>
                                                                <tr>
                                                                    <td style="font-weight: bold">Arbetsresultat</td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                    <td>&nbsp;</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <p>
                                                            Detta sätt att hantera en lönefaktor har flera brister:
                                                        </p>
                                                        <p>
                                                        </p><ul>
                                                            <li>Värderingsfaktorn har inte definierats. Eftersom arbetsresultat kan bedömas utifrån olika perspektiv, exempelvis kvalitet, kvantitet eller kanske något annat, ger en lönefaktor av det här slaget ingen vägledning.</li>
                                                            <li>Det kan leda till onödiga kostnader i verksamheten. Det gäller exempelvis om fastställda kvalitetsmål överträffas.</li>
                                                            <li>Eftersom de olika graderna inte är relaterade till några fastställda krav kommer graderingen att innebära att personer värderas i förhållande till varandra, inte till kraven i lönefaktorn.</li>
                                                        </ul>
                                                        <p></p>
                                                        <p>
                                                            En värderingsfaktor bör definieras endast utifrån ett perspektiv. Ska individen bedömas utifrån flera perspektiv bör flera värderingsfaktorer användas, en för respektive perspektiv.
                                                            Det kan exempelvis vara en för kvalitet, en för kvantitet etcetera.
                                                        </p>



                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Exempel på tydligare sätt att beskriva kraven
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Att formulera lönefaktorer som har med sättet att utföra arbetet på eller den anställdas egenskaper är alltså inte helt lätt. Ska sådana lönefaktorer ändå användas måste man arbeta igenom dem väl.
                                                        </p>
                                                        <p>
                                                            Nedan ges några exempel på hur krav på sättet att utföra arbetet eller krav på den anställdas egenskaper kan beskrivas tydligare.
                                                        </p>
                                                    </div>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Lönefaktorn Kvalitet i arbetet
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Med denna lönefaktor fokuseras på rätt kvalitet i förhållande till fastställda kvalitetskrav. Utgångspunkten är här att kvalitetskraven är fastställda och tydligt beskrivna. I det läget kan det räcka med två grader för lönefaktorn:
                                                                    </p>
                                                                    <p>
                                                                    </p><table cellspacing="0" border="0">
                                                                        <tbody>
                                                                            <tr><td style="width:60px">Grad 1</td><td>Individen uppfyller inte upprättade kvalitetskrav.</td></tr>
                                                                            <tr><td style="width:60px">Grad 2</td><td>Individen uppfyller upprättade kvalitetskrav.</td></tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <p></p>
                                                                    <p>
                                                                        Man kan också utvidga definitionen av de olika graderna genom att koppla samman bedömningen med genomgången kvalitetsutbildning.
                                                                    </p>
                                                                    <p>
                                                                    </p><table cellspacing="0" border="0">
                                                                        <tbody>
                                                                            <tr><td style="width:60px" valign="top">Grad 1</td><td>Har begränsad kännedom om gällande kvalitetskrav<br>Anställd mindre än tre månader.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 2</td><td>Har kännedom om gällande kvalitetskrav<br>Har genomgått kvalitetsutbildning steg 1.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 3</td><td>Har god kännedom om gällande kvalitetskrav<br>Har genomgått kvalitetsutbildning steg 2.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 4</td><td>Har mycket god kännedom om gällande kvalitetskrav<br>Har genomgått kvalitetsutbildning steg 3.</td></tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <p></p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Lönefaktorn Problemlösning och självständighet
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Denna lönefaktor värderar förmågan att förutse, analysera och på eget initiativ lösa problem som avviker från fastlagda rutiner. Definitionen av de olika graderna kan göras på följande sätt:
                                                                    </p>
                                                                    <p>
                                                                    </p><table cellspacing="0" border="0">
                                                                        <tbody>
                                                                            <tr><td style="width:60px" valign="top">Grad 1</td><td>Ändringar i arbetet avgörs av annan person.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 2</td><td>Ändringar i arbetet avgörs oftast av annan person.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 3</td><td>Beslut om ändringar i arbetet fattas i regel av individen själv, utan samråd med annan person.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 4</td><td>Mycket självständigt beslutsfattande.</td></tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <p></p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Lönefaktorn Ordning och reda
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Denna lönefaktor värderar förmågan att hålla ordning på arbetsplatsen, både i den egna omedelbara närheten och i gruppens arbetsområde som helhet. Definitionen av de olika graderna kan vara:
                                                                    </p>
                                                                    <p>
                                                                    </p><table cellspacing="0" border="0">
                                                                        <tbody>
                                                                            <tr><td style="width:60px" valign="top">Grad 1</td><td>Uppfyller inte kraven på ordning och reda på arbetsplatsen enligt gällande rutiner, exempelvis 5S.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 2</td><td>Uppfyller kraven på ordning och reda på arbetsplatsen enligt gällande rutiner, exempelvis 5S.</td></tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <p></p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <v-expansion-panels variant="accordion">
                                                        <v-expansion-panel class='theme-orange'>
                                                            <v-expansion-panel-title color="orange">
                                                                Lönefaktorn Förbättringsarbete
                                                            </v-expansion-panel-title>
                                                            <v-expansion-panel-text>
                                                                <div class="pb-2">



                                                                    <p>
                                                                        Denna lönefaktor avser förmågan att se hur förbättringar kan genomföras i produktion och av produkter. Den skulle kunna definieras exempelvis enligt nedan:
                                                                    </p>
                                                                    <p>
                                                                    </p><table cellspacing="0" border="0">
                                                                        <tbody>
                                                                            <tr><td style="width:60px" valign="top">Grad 1</td><td>Tar ansvar för att rapportera korrekt i företagets produktions- och tidssystem  samt uppmärksammar avvikelser.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 2</td><td>Uppmärksammar behov av och medverkar till förbättringar av rutiner och instruktioner.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 3</td><td>Arbetar förebyggande så att reklamationer och kvalitetsproblem inte uppstår.</td></tr>
                                                                            <tr><td style="width:60px" valign="top">Grad 4</td><td>Tar aktivt ansvar för att driva förbättringsaktiviteter inom eget ansvarsområde.</td></tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <p></p>



                                                                </div>
                                                                <div class="mt-5">

                                                                </div>
                                                            </v-expansion-panel-text>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    VERKTYGET – FÖRSLAG TILL INDIVIDFAKTORER/GRADER/POÄNG
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">
                                        <p>
                                            Verktyget innehåller ett förslag till faktorer som kan användas vid värdering av individer.
                                            Det är möjligt att använda dessa faktorer, byta ut eller lägga till en eller flera faktorer. Det är också möjligt att vikta om.
                                            Vår rekommendation är att använda verktygets faktorer vid en provvärdering och sedan analysera resultatet och därefter ta ställning till eventuella förändringar.
                                        </p>
                                        <p>
                                            Om du vill göra förändringar är din arbetsuppgift att:
                                        </p><ol>
                                            <li>Skapa individfaktorer.</li>
                                            <li>Välja faktor och skapa grader med poäng.</li>
                                        </ol>
                                        <p></p>
                                        <p>
                                            När du skapar ett tillägg med Beräkningstyp 0 och Omfattning Individ inaktiveras Gradnr, Beskrivning och Poäng. Det beror på att denna typ av tillägg inte kan byggas upp genom olika typer av skalor.
                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <wage-individual-factors v-bind:disabled="writeindividualaddons == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-individual-factors>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hidedynamic == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 6}" @click="step = 6">
                        <span v-html="'Rörlig lönedel'"></span>
                    </div>
                </div>
                <div v-if="step == 6" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step6-rorlig-lonedel-utveckling"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,dynamic-wagepart,development">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Rörlig lönedel och arbetsorganisatorisk utveckling
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>


                                        <p>
                                            Den rörliga lönedelen syftar till att fånga upp prestationen i mätbara termer.
                                        </p>
                                        <p>
                                            Ibland uppfattas den positivt, då den ger de anställda möjlighet att påverka sin lön. Ibland uppfattas den negativt. Det kan då bero på att lönefaktorerna utformats så att de blir ett hinder för att utveckla arbetsorganisationen. De kan exempelvis hämma samarbetet i gruppen om de mäts på individnivå. De kan också uppmuntra till onödig specialisering eller för hög arbetstakt, med risk för arbetsskador och bristfällig kvalitet.
                                        </p>
                                        <p>
                                            På samma sätt som vid valet av övriga lönefaktorer, bör man i diskussionen om eventuella rörliga lönedelar alltid ställa frågan: Vad vill vi uppnå? Vad ska denna lönedel styra mot?
                                        </p>


                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    VERKTYGET – RÖRLIG LÖNEDEL
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">
                                        <p>
                                            I de fall rörlig lönedel ska användas blir din arbetsuppgift att:
                                        </p><ol>
                                            <li>Skapa rörliga faktorer.</li>
                                            <li>Välja värderingsfaktor och skapa grader.</li>
                                        </ol>
                                        Ingen automatisk uppdatering av utfall sker. Värdet av utfall får manuellt läggas in för att rörlig lönedel ska komma med i lönestatistiker.
                                        <p></p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <wage-dynamic-wagepart v-bind:disabled="writedynamic == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-dynamic-wagepart>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hideindividuals == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 7}" @click="step = 7">
                        <span v-html="'Inplacering av individer'"></span>
                    </div>
                </div>
                <div v-if="step == 7" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step7-beskrivning-regelverk"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,placement,rules">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Beskrivning av regelverk
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        För att lönesystemet ska kunna tillämpas konsekvent krävs ett tydligt regelverk. Nedan ges olika förslag.
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Inplacering i lönesystemet vid lönesystemsskifte
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">



                                                        <p>
                                                            Inplaceringen i det nya lönesystemet ska göras av företag och fack gemensamt.
                                                        </p>
                                                        <p>
                                                            Utgångspunkten bör vara att de anställda ska få befattningslönetillägg för de utvecklingsklossar inom vilka de utför arbete. Såväl den totala lönekostnaden, som enskilda individers tidigare lön ska garanteras.
                                                        </p>
                                                        <p>
                                                            Vid inplaceringen kommer man upptäcka att vissa har fel lön i förhållande till inplaceringen i det nya lönesystemet. Har de lägre lön ska den förstås höjas. För dem med högre lön ska utvecklingsplaner tas fram så att dessa personer snarast möjligt utvecklas till rätt lönenivå. Det bör också regleras hur den högre lönen i annat fall ska komma i fas med inplaceringen i det nya lönesystemet. Vanligen sker infasningen stegvis i de kommande löneförhandlingarna genom att lönepåslaget då blir mindre än det annars hade varit.
                                                        </p>
                                                        <p>
                                                            Ambitionen ska vara att så många som möjligt har rätt inplacering redan från start.
                                                        </p>
                                                        <p>
                                                            Den provinplacering som gjordes vid testningen av det nya lönesystemet är en bra utgångspunkt för överläggningarna med arbetsgivaren om inplacering.
                                                        </p>



                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Uppflyttning
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">



                                                        <p>
                                                            Det måste finnas tydliga regler för när och hur uppflyttning i lönesystemet görs.
                                                        </p>
                                                        <p>
                                                            Tidpunkten för uppflyttning kan variera. Ibland görs den direkt när en anställd tagit på sig arbetsuppgifterna i ett visst utvecklingsblock, ibland görs den vid vissa bestämda avstämningstillfällen eller när arbetet utförts självständigt under en viss period.
                                                        </p>
                                                        <p>
                                                            Det förekommer också att uppflyttning sker efter genomförd utbildning eller sedan arbetstagaren avlagt prov som bekräftar att han/hon har kompetens för ett visst utvecklingsblock. IF Metalls lönepolitiska uppfattning är dock att lönen ska sättas efter vilket arbete man utför och inte efter utbildning. Det kan därför finnas skäl att avvakta tills personen också utför arbetsuppgifterna ifråga.
                                                        </p>
                                                        <p>
                                                            Viktigt är att uppflyttningen hålls skild från löneförhandling enligt riksavtalet. Detta eftersom löneförhandlingen handlar om nivån på trapporna i lönesystemet, medan uppflyttningen handlar om ”springet” i trapporna.
                                                        </p>
                                                        <p>
                                                            Ibland finns regler om att arbetet ska utföras återkommande för att befattningslönetillägget ska betalas ut. Här bör anges vad som ska gälla om arbetet inte längre utförs återkommande. Ska det bedömas på samma sätt om det är orsakat av att en maskin ställts av en tid, som om det beror på att den anställda helst inte vill utföra arbetet? Dessutom måste anges vad som avses med ”återkommande”.
                                                        </p>
                                                        <p>
                                                            I regelsystemet ska det också anges hur beslutet om uppflyttning ska tas. Såväl arbetstagaren, som det lokala facket och arbetsledaren ska kunna föreslå uppflyttning. Själva beslutet kan fattas på olika sätt. I vissa fall tas det efter samråd mellan chef och anställd, i andra fall efter förhandling mellan parterna eller i en partssammansatt lönekommitté.
                                                        </p>
                                                        <p>
                                                            Det senare kan i vissa fall vara ett sätt att säkra att uppflyttning bara görs när det är motiverat och på de grunder som anges i lönesystemet.
                                                        </p>
                                                        <p>
                                                            Oavsett hur beslutet fattas, måste både det lokala facket och företaget ta ansvar för att uppflyttningar och lönehöjningar bara sker på de grunder som anges i lönesystemet.
                                                        </p>



                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Vid omplacering eller när en arbetsuppgift upphör
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">



                                                        <p>
                                                            Vad ska gälla om en anställd omplaceras till ett annat arbete eller inte längre kan utföra vissa arbetsuppgifter av exempelvis medicinska skäl?
                                                        </p>
                                                        <p>
                                                            Svårigheter att utföra en viss arbetsuppgift ska inte hindra utveckling i arbete och lön vad gäller övriga utvecklingsblock inom befattningen.
                                                        </p>
                                                        <p>
                                                            Om omplacering måste ske ska arbetstagaren i första hand erbjudas arbete inom befattningar med likvärdiga utvecklingsmöjligheter. Görs omplaceringen till en lägre betald befattning bör det finnas ett löneskydd som ger en gradvis avtrapp-ning till lönen för det nya arbetet. Här kan de centrala avtalens stupstockar för löneskydd vid omplacering vara en utgångspunkt.
                                                        </p>
                                                        <p>
                                                            Beror omplaceringen på en arbetsskada som uppstått i den tidigare befattningen bör den anställda få behålla sina befattningstillägg.
                                                        </p>



                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Dialog mellan chef och anställd
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">



                                                        <p>
                                                            Chef och anställd ska tillsammans gå igenom vilka möjligheter det finns till utveckling i arbetet i form av olika utvecklingsblock. I detta samtal ska också lönesystemet beskrivas, så att det är klart vad utvecklingen i arbetet ger i form av utveckling i lön.
                                                        </p>
                                                        <p>
                                                            Som resultat av samtalet ska en utbildningsplan tas fram för den anställda där det framgår inte bara vilken kompetensutveckling som ska genomföras, utan också när och hur. Denna utbildningsplan ska finnas med som underlag för bemanningsplaneringen.
                                                        </p>



                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    VERKTYGET – INPLACERING
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Skriv in anställda
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Det är möjligt att hoppa över att skriva in anställningsdatum, yrkets startdatum och personnummer. Det bör dock noteras att dessa uppgifter är av betydelse för olika typer av löneanalyser – exempelvis lön utifrån ålder och anställningstid i lika arbete.
                                                        </p>
                                                        <p>
                                                            Yrkets startdatum beräknas utifrån personers tidigare erfarenhet. Har en anställd exempelvis två års erfarenhet
                                                            som hon/han kan tillgodoräkna sig klickar eller fyller du i datum två år tillbaka i tiden. Om anställningsdatum är
                                                            2010-01-01 blir Yrkets startdatum 2008-01-01.
                                                        </p>
                                                        <p>
                                                            I verktyget finns en funktion under Administration i menyraden som du kan använda för att automatiskt lägga upp de anställda. Funktionen heter Importera anställda.
                                                        </p>
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Skapa anställda och välja befattning för rätt inplacering.</li>
                                                        </ol>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-employee-admin v-bind:disabled="writeindividuals == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-admin>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Individens kompetens
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Välja befattning.</li>
                                                            <li>Välja anställd.</li>
                                                            <li>
                                                                Kryssa för:<br>
                                                                - Godkänd (har direkt effekt på individens lön),<br>
                                                                - Nästa steg (påverkar individens utvecklingsplan) eller<br>
                                                                - Utveckling (anger den potentiella utvecklingen för individen).<br>
                                                                Samtliga tre, Godkänt - Nästa steg - Utveckling, påverkar lönestatistiken.
                                                            </li>
                                                            <li>Klicka Spara kompetens.</li>
                                                        </ol>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-employee-competences v-bind:disabled="writeindividuals == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-competences>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Kompetensmatris
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Välja befattning och kontrollera kompetensmatrisen.</li>
                                                        </ol>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-employee-competence-matrix v-bind:disabled="writeindividuals == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-competence-matrix>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Individuell lönedel
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Uppdatera individfaktorer.</li>
                                                            <li>Välja befattning.</li>
                                                            <li>Välja anställd.</li>
                                                            <li>Eventuellt lägga till/radera enskilda individfaktorer och ändra grad för individ.</li>
                                                        </ol>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-employee-individual v-bind:disabled="writeindividuals == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-individual>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Rörlig lönedel
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Uppdatera rörliga faktorer.</li>
                                                            <li>Välja befattning.</li>
                                                            <li>Välja anställd.</li>
                                                            <li>Eventuellt lägga till/radera enskilda rörliga faktorer och ändra grad för individ.</li>
                                                        </ol>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-employee-dynamic v-bind:disabled="writeindividuals == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-dynamic>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hidemoney == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 8}" @click="step = 8">
                        <span v-html="'Pengar i systemet'"></span>
                    </div>
                </div>
                <div v-if="step == 8" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step8-lonesystemet-som-drivkraft"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,money,development">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    Lönesystemet som drivkraft
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        <p>
                                            IF Metall vill att lönesättningen ska understödja en utveckling av befattningar och därmed en arbetsorganisatorisk utveckling. Grunden för detta är att:
                                        </p>
                                        <p>
                                        </p><ul>
                                            <li>Personer successivt kan utvecklas i arbetet.</li>
                                            <li>Arbetsorganisatorisk utveckling skapar ökad effektivitet och därmed trygghet för industriarbetarna.</li>
                                        </ul>
                                        <p></p>
                                        <p>
                                            För att ett lönesystem ska stödja arbetsorganisatorisk utveckling räcker det inte med att lönesystemet innehåller en befattningslönedel. Om möjligheterna för personer att växa i befattningen är små eller orättvisa skapar befattningslönedelen liten utvecklingskraft. På samma sätt kan utvecklingskraften minskas eller försvinna om lönesystemet också innehåller individuella lönekomponenter som uppfattas som orättvisa.
                                        </p>
                                        <p>
                                            Varje lönesystem måste analyseras utifrån vad som skapar löneskillnader mellan personer och vilka effekter det kan få för befattningsutvecklingen.
                                        </p>
                                        <p>

                                        </p>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Ett exempel
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">



                                                        <p>
                                                            Lönesystemet består av tre lönedelar. Grundlönedel, befattningslönedel och individuell lönedel.
                                                            Till befattningslönedelen har skapats regler som gör det möjligt för alla att växa i befattningen.
                                                            På sikt ska samtliga personer regelbundet utföra gruppens samtliga arbetsuppgifter.
                                                            Det finns också tydliga regler för när högre lön ska utgå för nya befattningsklossar.
                                                            Den individuella lönedelen premierar personers samarbetsförmåga och kreativitet.
                                                        </p>
                                                        <p>
                                                            En analys av de olika lönedelarnas betydelse i systemet visar:
                                                        </p>
                                                        <p>
                                                        </p><table cellspacing="0" border="0">
                                                            <tbody>
                                                                <tr><td style="width:140px">Lönedel</td><td style="width:100px">Genomsnitt</td><td>Andel</td></tr>
                                                                <tr><td>Individuell lönedel<br>ILD</td><td>2 000 kr</td><td>9%</td></tr>
                                                                <tr><td>Befattningslönedel<br>BLD</td><td>2 000 kr</td><td>9%</td></tr>
                                                                <tr><td>Grundlönedel<br>GLD</td><td>19 500 kr</td><td>82%</td></tr>
                                                                <tr><td>Summa</td><td></td><td>100%</td></tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <p>
                                                            Vi tänker oss att lönesystemet skapar följande löneskillnader mellan personer:
                                                        </p>
                                                        <p>
                                                        </p><table cellspacing="0" border="0">
                                                            <tbody>
                                                                <tr><td style="width:140px"></td><td style="width:100px">Min-max</td><td style="width:80px">Diff i kr</td><td>Diff i %</td></tr>
                                                                <tr><td>Individuell lönedel<br>ILD</td><td>0–3 000 kr</td><td>3 000 kr</td><td>35%</td></tr>
                                                                <tr><td>Befattningslönedel<br>BLD</td><td>0-4 000 kr</td><td>4 000 kr</td><td>47%</td></tr>
                                                                <tr><td>Grundlönedel<br>GLD</td><td>19 000-20 500 kr</td><td>1 500 kr</td><td>18%</td></tr>
                                                                <tr><td>Summa</td><td></td><td>8 500 kr</td><td>100%</td></tr>
                                                            </tbody>
                                                        </table>
                                                        <p></p>
                                                        <p>
                                                            Exemplet visar att grundtryggheten i lönesystemet är hög. Av den genomsnittliga utgående lönen tillhör 82 procent grundlönen.
                                                        </p>
                                                        <p>
                                                            Både befattnings- och individuell lönedel utgör i genomsnitt vardera 9 procent av utgående lön.
                                                        </p>
                                                        <p>
                                                            I exemplet är den individuella lönedelens betydelse i systemet 9 procent. Det kan tyckas lite och därför försvarbart. Den enskilde upplever emellertid inte rättvisan i form av en lönedels betydelse i systemet,
                                                            utan snarare de löneskillnader som kan skapas mellan individer. Den individuella lönedelens betydelse på 9 procent i lönesystemet omvandlas till en möjlig löneskillnad mellan personer på 35 procent.
                                                        </p>
                                                        <p>
                                                            Lönesystemet skapar löneskillnader i den del som utvecklar företag och individer på möjliga 47 procent och att göra karriär till 18 procent. Analysen visar att lönesystemet styr för lite mot utveckling.
                                                        </p>



                                                    </div>
                                                    <div class="mt-5">

                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel eager class='theme-purple'
                                data-manual-info-block="wagesetting-step8-verktyg-pengar-intro"
                                data-manual-info-scope="Scenario"
                                data-manual-module="WageSetting"
                                data-manual-overview-section="WageSetting"
                                data-manual-complexity="Mellan"
                                data-manual-info-tags="wagesetting,money,tool-intro">
                                <v-expansion-panel-title color="purple" data-manual-info-title>
                                    VERKTYGET – PENGAR I SYSTEMET
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                        I detta steg ska du lägga in pengar på de lönedelar som lönesystemet är uppbyggt av. Det är möjligt att välja olika alternativ för respektive lönedel och verktyget räknar automatiskt ut löneutfallet.<br><br>
                                        Genom att det finns olika valmöjligheter för hur pengar kan fördelas i lönesystemet kan du enkelt få en överblick över vilka effekter olika alternativa konstruktioner har på löneutfall och lönespridning.<br><br>
                                    </div>

                                    <v-expansion-panels variant="accordion">

                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Grundlön
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Välja alternativ för att fastställa grundlön.</li>
                                                            <li>Fylla i uppgifter enligt valt alternativ.</li>
                                                        </ol>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-money-base-salary v-bind:disabled="writemoney == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-money-base-salary>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Befattningslön
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Välja alternativ för att fastställa befattningslön.</li>
                                                            <li>Fylla i uppgifter enligt valt alternativ.</li>
                                                        </ol>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-money-position-salary v-bind:disabled="writemoney == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-money-position-salary>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Individuell lönedel
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">

                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-money-individual-salary v-bind:disabled="writemoney == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-money-individual-salary>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        <v-expansion-panels variant="accordion">
                                            <v-expansion-panel class='theme-green'>
                                                <v-expansion-panel-title color="green">
                                                    Rörlig lönedel
                                                </v-expansion-panel-title>
                                                <v-expansion-panel-text>
                                                    <div class="pb-2">
                                                        <p>
                                                            Din arbetsuppgift är att:
                                                        </p><ol>
                                                            <li>Välja rörlig faktor.</li>
                                                            <li>Ange lön för varje rörlig faktorgrad.</li>
                                                        </ol>
                                                        <p></p>
                                                    </div>
                                                    <div class="mt-5">
                                                        <wage-money-dynamic-salary v-bind:disabled="writemoney == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-money-dynamic-salary>
                                                    </div>

                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-expansion-panels>
                                    <div class="mt-5">

                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>

                <div v-if="hideresult == false" class="p-0 d-block d-md-none col-12">
                    <div class="purple my-1 mobile-button rounded" v-bind:class="{'selected':step == 9}" @click="step = 9">
                        <span v-html="'Resultatet'"></span>
                    </div>
                </div>
                <div v-if="step == 9" class="col-12 p-0">
                    <div class="col-12 p-0">
                        <v-expansion-panels variant="accordion">
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    Den totala lönebilden
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <wage-result-totaloverview v-bind:disabled="writeresult == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-result-totaloverview>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    Stora löneanalysen
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <wage-result-largeanalysis v-bind:disabled="writeresult == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-result-largeanalysis>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    Lönestatistik
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <wage-result-statistics v-bind:model='model' v-bind:disabled="writeresult == false" v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-result-statistics>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel class='theme-purple'>
                                <v-expansion-panel-title color="purple">
                                    Individens lön
                                </v-expansion-panel-title>
                                <v-expansion-panel-text class="top-expanded">
                                    <div class="pt-2 pb-4 col-md-7">

                                    </div>

                                    <v-expansion-panels variant="accordion">

                                    </v-expansion-panels>
                                    <div class="mt-5">
                                        <wage-result-individual v-bind:disabled="writeresult == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-result-individual>
                                    </div>


                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>


                    </div>
                </div>
            </div>
        </div>
    </div>



    <!-- to here -->

</template>


<script>

    /* eslint-disable */

    //import WorkOrganisationService from "../../Services/WorkOrganisationService";
    //import WageService from "../../Services/WageService";

    //import { ref } from 'vue'

    import CommonRule from '../../common/common-rule.vue'

    import WageBlockDificultyLevel from './wage-block-dificulty-level.vue'
    import WageBlockDificultyLevelAnalysis from './wage-block-dificulty-level-analysis.vue'
    import WageBlockDificultyLevelEvaluation from './wage-block-dificulty-level-evaluation.vue'

    import WageDynamicWagepart from './wage-dynamic-wagepart.vue'

    import WageEvaluateFactors from './wage-evaluate-factors.vue'
    import WagePositions from './wage-positions.vue'
    import WageEvaluateBasework from './wage-evaluate-basework.vue'
    import WageEvaluateAnalysis from './wage-evaluate-analysis.vue'

    import WageIndividualFactors from './wage-individual-factors.vue'

    import WageEmployeeAdmin from './wage-employee-admin.vue'
    import WageEmployeeCompetenceMatrix from './wage-employee-competence-matrix.vue'
    import WageEmployeeCompetences from './wage-employee-competences.vue'
    import WageEmployeeDynamic from './wage-employee-dynamic.vue'
    import WageEmployeeIndividual from './wage-employee-individual.vue'

    import WageMoneyBaseSalary from './wage-money-base-salary.vue'
    import WageMoneyPositionSalary from './wage-money-position-salary.vue'
    import WageMoneyIndividualSalary from './wage-money-individual-salary.vue'
    import WageMoneyDynamicSalary from './wage-money-dynamic-salary.vue'


    import WageResultIndividual from './wage-result-individual.vue'
    import WageResultLargeanalysis from './wage-result-largeanalysis.vue'
    import WageResultStatistics from './wage-result-statistics.vue'
    import WageResultTotaloverview from './wage-result-totaloverview.vue'


    export default {

        name: 'wage-setting',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            

            writeindividualaddons: {
                type: Boolean,
                required: false,
                default: false,
            },
             hideindividualaddons: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeevaluatedevelopmentblocks: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideevaluatedevelopmentblocks: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeevaluatebasework: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideevaluatebasework: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeoverview: {
                 type: Boolean,
                 required: false,
                 default: false,
            },
            hideoverview: {
                type: Boolean,
                required: false,
                default: false,
            },
            writesalarysteps: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidesalarysteps: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeindividuals: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidedynamic: {
                type: Boolean,
                required: false,
                default: false,
            },
            writedynamic: {
                type: Boolean,
                required: false,
                default: false,
            },
            
            hideindividuals: {
                type: Boolean,
                required: false,
                default: false,
            },
            writemoney: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidemoney: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeresult: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideresult: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonRule,
            WageBlockDificultyLevel,
            WageBlockDificultyLevelAnalysis,
            WageBlockDificultyLevelEvaluation,
            WageDynamicWagepart,
            WageEvaluateFactors,
            WagePositions,
            WageEvaluateBasework,
            WageEvaluateAnalysis,
            WageIndividualFactors,
            WageEmployeeAdmin,
            WageEmployeeCompetenceMatrix,
            WageEmployeeCompetences,
            WageEmployeeDynamic,
            WageEmployeeIndividual,
            WageMoneyBaseSalary,
            WageMoneyPositionSalary,
            WageMoneyIndividualSalary,
            WageMoneyDynamicSalary,
            WageResultLargeanalysis,
            WageResultStatistics,
            WageResultTotaloverview,
            WageResultIndividual,
        },
        methods: {
            positionSelected(newVal) {
                this.selectedJobPosition = newVal;
            }
        },

        data() {
            return {
                step: 1,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                selectedJobPosition: null,
                newWindow: {},
            };
        },
        watch: {
            //selectedPosition1: function(newVal){
            //    this.getWorkTasks(newVal);
            //    this.getWorkBlocks(newVal);
            //},
           
        },
        mounted() {
            this.internalModel = this.model;
        },
        setup () {
            //const workDialog = ref()
            //return { workDialog }
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .large-button {
        text-align: center;
        display: grid;
        align-items: center;
        /*width:80px;*/
        min-height: 90px;
        background-color: blue;
        color: white;
        cursor: pointer;
        font-size: 15px;
    }

    /*
    .large-button.selected {
        background-color: lightblue !important;
    }
    */
    .input{
        border:none;
        border-bottom:1px solid #ccc;
    }

    td {
        word-wrap: break-word;
        word-break: break-all;
    }

    .drop{
        color:black;
        text-decoration:none;
        font-size:20px;
    }

    .top-expanded {
        
    }

    /*
    .theme-purple .v-expansion-panel-title--active {
        background-color: #7D478E !important;
    }

    .top-title {
        background-color: #7D478E !important;
    }

    */



    .theme-purple .v-expansion-panel-title {
        background-color: #845893 !important;
        color: white !important;
    }

    .theme-purple .v-expansion-panel-text {
        background-color: #fbedff !important;
    }


    .theme-green .v-expansion-panel-title {
        background-color: #62B965 !important;
        color: white !important;
    }

    .theme-green .v-expansion-panel-text {
        background-color: #F1F1F1 !important;
    }



    .theme-orange .v-expansion-panel-title {
        background-color: #e79925 !important;
        color: white !important;
    }

    .theme-orange .v-expansion-panel-text {
        background-color: #fff7eb !important;
    }
    
    

</style>
